const resources = {
  en: {
    "translation": {
      go_step2: "Go to Step 2",
      shareText: "मी Gallant स्कॅन करून बक्षीस जिंकलं! 🎁 \nतुम्हीही Gallant खरेदी करा, स्कॅन करा आणि बक्षीस जिंका",
      Share: "Share",
      confirmation: "Confirmation",
      All_products_Scanned: "All products Scanned ?",
      No: "No",
      Yes: "Yes",
      invalid_OTP: "Invalid OTP ",
      resend_OTP: "Resend OTP",
      Mega_Draw_Code: "Mega Draw Code",
      Next: "Next",
      all_set: "You're all set!",
      Reward_Won: "Reward Won",
      Spin_Wheel_Win: "Spin the Wheel & Win!",
      Spin_Wheel: "Spin Wheel",
      Continue: "Continue",
      Spin_Win: "Spin and Win",
      Eligible_to_win: "You are now Eligible to win",
      Spin_Now: "Spin Now",
      Product_Serial_Number: "Product Serial Number",
      Done: "Done",
      Step_1: "Step 1",
      Step_2: "Step 2",
      Update_Farming: "Step 1 : Update Farming Details",
      Select_Crop: "Select Crop",
      Soyabean: "Soyabean",
      Ground_Nut: "Groundnut",
      Total_acres_this_Season: "Total Acres this season",
      Total_acres: "Total acres",
      Update: "Update",
      Farming_details_update: "Farming details updated successfully.",
      step_2_click: "Click on OK for STEP 2.",
      Ok: "Ok",
      Click_ok: "Farming details updated successfully. Click on OK to check Eligibility and Rewards",
      Congratulations: "Congratulations !!!",
      claim_gifts: "You're all set! Now, Claim Your Gifts",
      Name: "Name",
      total_acresErrorMsg: "Please enter acres",
      language: "english",
      visit: "Read",
      thanks_text: "Thank you for participating in the Corteva Reward (Strongarm) Program!",
      eligible_text: "To be eligible for exciting gifts, please ensure you complete all mandatory steps.",
      Strongarm_Survey: "Strongarm Reward Program",
      Enter_Details: "Enter Details",
      fillYourInformationHeading: "Fill in your details",
      selectPayment: {
        cashbackAmountLabel: "Cashback amount",
        proceedButton: "Proceed",
        bankDetails: "Bank account",
        upi: "UPI",
      },
      scanProductPage: {
        whatsappHelp: "Need help? Contact us on WhatsApp",
      },
      "SelectSteps": "SelectSteps",
      "profileText": " Your profile is getting created in Corteva Farmer Connect app. Please complete your registration",
      "termsandconiditionsURL": "http://uat.farmerconnect.in:7000/tracer-microsite/hindi/termsandconditions.php",
      "delegate": "Tracer",
      "loginLabel": "Mobile Number",
      "loginPlaceHolder": "Enter Mobile Number",
      "mobileErrorMsg": "Please enter mobile number",
      "submitBtn": "Submit",
      "loginBtn": "Login",
      "otpText": "OTP will be sent as an SMS to {mobileNumber}",
      "otpError": "Please enter a valid OTP",
      "OTPLabel": "OTP",
      "firstName": "First Name",
      "firstNameErrorMsg": "Please enter first name",
      "lastName": "Last Name",
      "lastNameErrorMsg": "Please enter last name",
      "pincode": "Pincode",
      "address": "Address",
      "done": "Done",
      "submit": "Submit",
      "scanTitle": "Scan QR code on Product",
      "scanning": "Scanning",
      "scan": "Scan",
      "rescan": "Rescan",
      "scanSteps": "Steps to scan the QR code",
      "stepOne": "Step 1: Find the QR code on the pouch",
      "stepTwo": "Step 2: Scan the QR code and submit",
      "spinToWin": "Claim Rewards",
      "scanProduct": "Scan Product",
      "SpinWheel": "Spin the Wheel to win rewards",
      "congratulations": "Congratulations",
      "giftcongratulations": "Congratulations, you are a winner!",
      "earned": "You have earned Rs. 20.00 cash for Tracer",
      "redeemCash": "Get Cash Payment",
      "ClaimReward": "Claim Reward",
      "updatesOnReward": "You are a winner with Tracer. Contact your local Corteva representative for updates on the reward",
      "paymentMode": "Select Payment Mode",
      "accountHolderName": "Account Holder Name",
      "accountHolderNameErrorMsg": "Account holder name is required",
      "accountNumber": "Account Number",
      "accountNumberErrorMsg": "Please enter account number",
      "IFSCCode": "IFSC Code",
      "IFSCCodeErrorMsg": "Please enter IFSC code",
      "confirm": "Confirm",
      "UPIErrorMsg": "UPI required",
      "transferSuccessText": "Your cash transfer <br> is successful",
      transferSuccessPage: {
        title: "Payment successful",
        message: "Your ₹{{amount}} cash payment was successful.",
        proceedButton: "Proceed",
      },
      "successSubtitile": "We have sent your money!",
      "goHome": "Go to Home Page",
      "delegateRewards": "Tracer Rewards",
      "claimList": "Claim List",
      "noClaimsFound": "No claims found",
      "noSuccessList": "No success list found",
      "reclaimList": "Reclaim List",
      "noReclaimList": "No reclaim list found",
      "termsAndConditions": "Terms and Conditions",
      "agreeText": "By submitting, you agree to our terms",
      "genuityCheck": "Genuinity Check",
      "genuityProduct": "This is Genuine Corteva Product",
      "FarmerConnect": "Go to Farmer Connect",
      "UpdateFarmingDetails": "Update Farming Details",
      "ViewProductInfo": "View Product Info & Share ",
      "resendOtp": "Resend OTP",
      "productName": "Product",
      "serialNO": "Serial No.",
      "alreadyLoginText": "Your number is also logged in to the Farmer Connect app. Press OK to log in.",
      "notRegisteredText": "Your number is not registered. Please register to participate in Tracer Blast.",
      "loginConfirm": "Login Confirmation",
      "Alert": "Alert!",
      "no": "No",
      "yes": "Yes",
      "OK": "OK",
      "amount": "Amount",
      "Date": "Date",
      "claim": "Claim",
      "successList": "Success List",
      "referenceId": "Reference ID",
      "status": "Status",
      "Scanmore": "Scan More",
      "Rewards": "Rewards",
      "reward": "Reward",
      "transfer": "Transfer",
      "home": "Home",
      "TC": "T&C",
      "ProductInfo": "Product <br> Information",
      "downloadBrochure": "Download Brochure <br> ",
      "programDetails": "Program Details",
      "delegateParticipate": "Tracer Friendship Blast - Participate",
      "award": "Award",
      "TermsandConditons": "Terms and Conditions",
      "and": "and",
      "privacyPolicy": "Privacy Policy",
      "BackToHome": "Back to Home Page",
      "ReferenceId": "Reference ID",
      "noData": "No data available",
      "mblnumberPlaceHolder": "Retailer's Mobile Number",
      "name": "Enter Name",
      "cottn": "Cotton",
      "corn": "Corn",
      "enterOTP": "Enter OTP",
      "login": "Login",
      "scanagain": "Scan Again",
      "cropErrorMsg": "Please select a crop",
      "nameErrorMsg": "Please enter your name",
      "Reclaim": "Reclaim",
      "Skip": "Skip",
      "Claim": "Claim",
      "StepsImage": "Tracer Double Blast - How to Participate",
      "UPI": "UPI",
      "bankDetails": "Bank Details",
      "confirmaccountNumber": "Confirm Account Number",
      "confirmaccountNumberErrorMsg": "Please enter Confirm Account Number",
      "confirmAccountNumberMismatch": 'The account number confirmation account number does not match',
      "cortevaInfo": "आपका नाम 'Corteva Farmer Connect' ऐप में जोड़ा (रजिस्टर किया) जा रहा है। जानकारी भरकर आप कोर्टेवा को अनुमति देते हैं कि वे समय-समय पर खेती और उत्पादों से जुड़ी जानकारी के लिए आपसे संपर्क करें।",
      "knowmore": "Learn More",
      "consentAgree": "Agree",
      "consentDecline": "Decline",
      "consentDetailsTitle": "सहमति विवरण",
      "consentDetails": "आपका नाम 'Corteva Farmer Connect' ऐप में पंजीकृत किया जा रहा है।\n\nआप जो व्यक्तिगत जानकारी (नाम, मोबाइल नंबर, फसल विवरण आदि) प्रदान करते हैं, वह Strongarm™ प्रोग्राम और संबंधित सेवाओं के लिए उपयोग की जाएगी।\n\nआप कोर्टेवा एग्रीसाइंस को यह अनुमति देते हैं कि वे समय-समय पर खेती, उत्पादों, ऑफ़र और प्रोग्राम से जुड़ी जानकारी के लिए आपसे कॉल, SMS या WhatsApp के माध्यम से संपर्क कर सकते हैं।\n\nआपकी जानकारी कोर्टेवा की गोपनीयता नीति के अनुसार सुरक्षित रखी जाएगी। आप कभी भी संपर्क करके अपनी सहमति वापस ले सकते हैं।\n\n'सबमिट' बटन पर क्लिक करके, आप उपरोक्त शर्तों से सहमत होते हैं।",
      "ChangeLanguage": "Change Language",
      "ShareNow": "Share Now",
      "gallant_usedErrorMsg": "Please select whether Gallant was used.",
      "will_buy_strongarm_this_seasonErrorMsg": "Please select whether you bought Strongarm this season.",
      "bottleScan": "Acres Scanned",
      "big_prize_opportunity_title": "बड़े इनाम जीतने का मौका",
      "big_prize_opportunity_desc": "ज़्यादा स्कैन, बड़े इनाम",
      "scan_more": "और स्कैन करें",
      "scan_more_win_bigger_gifts_title": "Scan More, Win Bigger Gifts!",
      "scan_more_win_bigger_gifts_desc": "Every additional scan brings you closer to exciting rewards.",
      "next_gift_label": "For the next gift",
      "scan_more_packets_label": "more bottles to scan.",
      "reward_history": "Reward History",
      "scanned_products": "स्कैन किए गए उत्पाद",
      "scan_date": "Scan Date",
      "packet_id": "Product Name",
      "gift_history": "Gift History",
      "reward_win_date": "Reward Win Date",
      "reward": "Reward",
      "status": "Status",
      "share": "Share",
      "have_they_used_gallant": "Have they used Gallant in the past?",
      "willBuyStrongarmThisSeason": "Did you buy Strongarm this season?",
      "nextDay": "Next Day",
      "within3Days": "Within 3 Days",
      "after7Days": "After 7 Days",
      "thankYouForPurchase": "Thank you for your purchase.",
      "alreadyWonGift": "You have already won a gift with this mobile number.",
      "congratulationsYouWon": "Congratulations! You have won",
      "claimed": "Claimed",
    }
  },
  hi: {
    translation: {
      "Continue": "जारी रखें",
      shareText: "मैंने Gallant स्कैन कर इनाम जीता! 🎁 \nआप भी Gallant खरीदें, स्कैन करें और इनाम जीतें ",
      Share: "साझा करें",
      confirmation: "पुष्टीकरण",
      All_products_Scanned: "सभी उत्पाद स्कैन किये गये?",
      No: "नहीं",
      Yes: "हाँ",
      invalid_OTP: "अमान्य ओटीपी",
      resend_OTP: "ओटीपी फिर से भेजें",
      Mega_Draw_Code: "मेगा ड्रॉ कोड",
      Next: "आगे",
      all_set: "आप तैयार हैं!",
      Reward_Won: "इनाम जीता",
      Spin_Wheel: "इनामों का चक्का",
      Spin_Wheel_Win: "चक्का घुमाएं और इनाम जीतें!",
      go_step2: "चरण 2 पर जाएं",
      Spin_Win: "घुमाओ और जीतें",
      Eligible_to_win: "अब आप जीतने के लिए पात्र हैं",
      Spin_Now: "अभी घुमाएं",
      Product_Serial_Number: "उत्पाद का सीरियल नंबर",
      "Done": "पूर्ण हुआ",
      "Step_1": "चरण 1",
      "Step_2": "चरण 2",
      "Update_Farming": "चरण 1: खेती की जानकारी अपडेट करें",
      "Select_Crop": "फसल चुनें",
      "Soyabean": "सोयाबीन",
      "Ground_Nut": "मूंगफली",
      "Total_acres_this_Season": "इस सीजन की कुल एकड़",
      "Total_acres": "खेत का अकार (एकड़ में)",
      "Update": "अपडेट करें",
      "Farming_details_update": "खेती की जानकारी सफलतापूर्वक अपडेट हुई।",
      "step_2_click": "चरण 2 के लिए कृपया OK पर क्लिक करें।",
      "Ok": "स्वीकार करना",
      "Click_ok": "खेती का विवरण सफलतापूर्वक अपडेट किया गया। पात्रता और पुरस्कार देखने के लिए कृपया OK पर क्लिक करें।",
      "Congratulations": "बधाई हो!!!",
      "claim_gifts": "आप तैयार हैं! अब अपने उपहार प्राप्त करें।",
      language: "hindi",
      "total_acresErrorMsg": "कृपया एकड़ दर्ज करें",
      visit: "पढ़ें",
      Name: "नाम",
      thanks_text: "Corteva Reward (Strongarm) कार्यक्रम में भाग लेने के लिए धन्यवाद!",
      eligible_text: "रोमांचक उपहारों के लिए पात्र बनने के लिए, कृपया सभी आवश्यक चरण पूरे करें।",
      Strongarm_Survey: "स्ट्रॉन्गआर्म इनाम कार्यक्रम",
      Enter_Details: "जानकारी दर्ज करें",
      "SelectSteps": "चरण चुनें",
      "termsandconiditionsURL": "http://uat.farmerconnect.in:7000/tracer-microsite/hindi/termsandconditions.php",
      "profileText": "*आपकी प्रोफ़ाइल 'Corteva Farmer Connect' ऐप में पंजीकृत की जा रही है और आप भविष्य की विपणन गतिविधियों के लिए कोर्टेवा को आपसे संपर्क करने के लिए अधिकृत करते हैं।",
      delegate: "ट्रैसर",
      loginLabel: "मोबाइल नंबर",
      loginPlaceHolder: "मोबाइल नंबर",
      mobileErrorMsg: "कृपया मोबाइल नंबर दर्ज करें",
      submitBtn: "जमा करें",
      loginBtn: "लॉगिन",
      otpText: "ओटीपी {mobileNumber} पर एसएमएस के रूप में भेजा जाएगा",
      otpError: "कृपया मान्य OTP दर्ज करें",
      OTPLabel: "ओटीपी",
      firstName: "पहला नाम",
      firstNameErrorMsg: "कृपया प्रथम नाम दर्ज करें",
      lastName: "अंतिम नाम",
      lastNameErrorMsg: "कृपया अंतिम नाम दर्ज करें",
      pincode: "पिन कोड",
      address: "पता",
      done: "हो गया",
      submit: "उपस्थित करना",
      scanTitle: "गैलेंट की बोतल क्यूआर कोड स्कैन",
      scanning: "स्कैनिंग",
      scan: "स्कैन करें",
      rescan: "दोबारा स्कैन करें",
      scanSteps: "क्यूआर कोड को स्कैन करने के चरण",
      stepOne: "चरण 1: पाउच पर क्यूआर कोड खोजें",
      stepTwo: "चरण 2: क्यूआर कोड को स्कैन करें और सबमिट करें",
      spinToWin: "पुरस्कार का दावा करें",
      scanProduct: "उत्पाद स्कैन करें",
      SpinWheel: "चक्का घुमाओ और जीतो",
      congratulations: "बधाई हो",
      giftcongratulations: "बधाई हो, आप विजेता हैं।​",
      earned: "आपने रु. कमाए हैं. ट्रैसर के लिए 20.00 नकद",
      redeemCash: "नकद भुगतान पायें",
      ClaimReward: "इनाम का दावा करें",
      updatesOnReward: "आप ट्रैसर के साथ विजेता हैं। अपने स्थानीय कॉर्टेवा प्रतिनिधि से संपर्क करें इनाम पर अपडेट के लिए",
      paymentMode: "भुगतान मोड चुनें​",
      bankDetails: "बैंक विवरण",
      accountHolderName: "खाते का नाम​",
      accountHolderNameErrorMsg: "खाते का नाम आवश्यक है",
      accountNumber: "खाता संख्या​",
      accountNumberErrorMsg: "कृपया खाता संख्या दर्ज करें",
      IFSCCode: "IFSC कोड",
      IFSCCodeErrorMsg: "कृपया IFSC कोड दर्ज करें",
      confirm: "पुष्टि करें",
      UPIErrorMsg: "यूपीआई आवश्यक",
      transferSuccessText: "आपका नकद ट्रांसफर <br> सफल है​",
      successSubtitile: "हमने आपको आपका पैसा भेज दिया है!",
      goHome: "होम पेज पर जाएँ",
      delegateRewards: "ट्रैसर पुरस्कार",
      claimList: "दावा सूची",
      noClaimsFound: "कोई दावा नहीं मिला",
      noSuccessList: "कोई सफलता सूची नहीं मिली",
      reclaimList: "दुबारा दावा सूची",
      noReclaimList: "कोई पुनः दावा सूची नहीं मिली",
      termsAndConditions: "नियम और शर्तें",
      agreeText: "सबमिट करके आप हमारे साथ सहमत होते हैं",
      genuityCheck: "प्रामाणिकता जांच​",
      "genuityProduct": "यह असली कोर्टेवा उत्पाद है",
      "FarmerConnect": "किसान कनेक्ट पर जाएं",
      "UpdateFarmingDetails": "खेती की जानकारी अपडेट करें",
      "ViewProductInfo": "उत्पाद की जानकारी देखें और साझा करें",
      resendOtp: "OTP पुन: भेजें",
      productName: "उत्पाद",
      serialNO: "क्र. संख्या",
      alreadyLoginText:
        "आपका नंबर भी फार्मर कनेक्ट ऐप में लॉग इन है. लॉग इन करने के लिए ओके दबाएं।​",
      notRegisteredText:
        "आपका नंबर पंजीकृत नहीं है. कृपया ट्रैसर धमाका में भाग लेने के लिए पंजीकरण करें।​",
      loginConfirm: "लॉगिन पुष्टिकरण",
      Alert: "चेतावनी!",
      no: "नहीं",
      yes: "हाँ",
      OK: "स्वीकार करना",
      amount: "रुपये",
      Date: "तिथि",
      claim: "दावा",
      successList: "सफलता सूची",
      referenceId: "संन्दर्भ आईडी",
      status: "स्थिति",
      Scanmore: "और बोतल स्कैन करें​",
      Rewards: "पुरस्कार",
      reward: "पुरस्कार",
      transfer: "ट्रांसफर",
      home: "होम",
      TC: "T&C",
      ProductInfo: "उत्पाद की <br>जानकारी",
      downloadBrochure: "ब्रोशर डाउनलोड <br> करें",
      programDetails: "कार्यक्रम विवरण",
      delegateParticipate: " ट्रैसर दोस्ती धमाका - भाग लें",
      award: "पुरस्कार",
      TermsandConditons: "नियम और शर्तें",
      and: "आणि",
      privacyPolicy: "गोपनीयता धोरण",
      BackToHome: "होम पेज पर जायें",
      ReferenceId: "संदर्भ पहचान पत्र",
      noData: "कोई डेटा मौजूद नहीं",
      mblnumberPlaceHolder: 'खुदरा विक्रेता का मोबाइल नंबर',
      name: "नाम",
      cottn: "कपास",
      corn: "मक्का",
      enterOTP: "OTP दर्ज करें",
      login: "लॉगिन करें​",
      scanagain: "दोबारा स्कैन करें",
      cropErrorMsg: "कृपया फसल चुनें​",
      nameErrorMsg: "कृपया किसान का नाम दर्ज करें",
      Reclaim: "दुबारा दावा",
      Skip: "Skip",
      Claim: "दावा",
      StepsImage: "ट्रैसर डबल धमाका - ऐसे भाग लें",
      UPI: "UPI",
      sessionExperied: "सत्र समाप्त हो गया है। कृपया QR कोड स्कैन करें",
      "confirmaccountNumber": "खाता संख्या की पुष्टि करें",
      "confirmaccountNumberErrorMsg": "कृपया पुष्टि खाता संख्या दर्ज करें",
      "confirmAccountNumberMismatch": 'खाता संख्या पुष्टिकरण खाता संख्या मेल नहीं खाती',
      "cortevaInfo": "आपका नाम 'Corteva Farmer Connect' ऐप में जोड़ा (रजिस्टर किया) जा रहा है। जानकारी भरकर आप कोर्टेवा को अनुमति देते हैं कि वे समय-समय पर खेती और उत्पादों से जुड़ी जानकारी के लिए आपसे संपर्क करें।",
      "knowmore": "अधिक जानें",
      "consentAgree": "सहमत",
      "consentDecline": "अस्वीकार करें",
      "consentDetailsTitle": "सहमति विवरण",
      "consentDetails": "आपका नाम 'Corteva Farmer Connect' ऐप में पंजीकृत किया जा रहा है।\n\nआप जो व्यक्तिगत जानकारी (नाम, मोबाइल नंबर, फसल विवरण आदि) प्रदान करते हैं, वह Strongarm™ प्रोग्राम और संबंधित सेवाओं के लिए उपयोग की जाएगी।\n\nआप कोर्टेवा एग्रीसाइंस को यह अनुमति देते हैं कि वे समय-समय पर खेती, उत्पादों, ऑफ़र और प्रोग्राम से जुड़ी जानकारी के लिए आपसे कॉल, SMS या WhatsApp के माध्यम से संपर्क कर सकते हैं।\n\nआपकी जानकारी कोर्टेवा की गोपनीयता नीति के अनुसार सुरक्षित रखी जाएगी। आप कभी भी संपर्क करके अपनी सहमति वापस ले सकते हैं।\n\n'सबमिट' बटन पर क्लिक करके, आप उपरोक्त शर्तों से सहमत होते हैं।",
      "ChangeLanguage": "भाषा बदलें",
      "ShareNow": "अभी शेयर करें",
      "gallant_usedErrorMsg": "कृपया चुनें कि गैलेंट का उपयोग किया गया था या नहीं।",
      "will_buy_strongarm_this_seasonErrorMsg": "कृपया चुनें कि आपने इस सीज़न में स्ट्रॉन्गआर्म खरीदा था या नहीं।",
      "bottleScan": "स्कैन किए गए एकड़",
      "big_prize_opportunity_title": "बड़े इनाम जीतने का मौका",
      "big_prize_opportunity_desc": "ज़्यादा स्कैन, बड़े इनाम",
      "scan_more": "और स्कैन करें",
      "scan_more_win_bigger_gifts_title": "और स्कैन करें, बड़े उपहार जीतें!",
      "scan_more_win_bigger_gifts_desc": "हर अतिरिक्त स्कैन आपको शानदार पुरस्कारों के करीब लाता है।",
      "next_gift_label": "अगले उपहार के लिए",
      "scan_more_packets_label": "और बोतल स्कैन करें।",
      "reward_history": "पुरस्कार का इतिहास",
      "scanned_products": "स्कैन किए गए उत्पाद",
      "scan_date": "स्कैन की तारीख",
      "packet_id": "उत्पाद का नाम",
      "gift_history": "उपहारों का इतिहास",
      "reward_win_date": "पुरस्कार जीतने की तारीख",
      "reward": "पुरस्कार",
      "status": "स्थिति",
      "share": "शेयर करें",
      "have_they_used_gallant": "क्या आपने अतीत में गैलेंट का इस्तेमाल किया है?",
      "willBuyStrongarmThisSeason": "क्या आपने इस सीज़न में स्ट्रॉन्गआर्म ख़रीदा था?",
      "nextDay": "अगले दिन",
      "within3Days": "अगले 3 दिन",
      "after7Days": "7 दिनों के बाद",
      "thankYouForPurchase": "आपकी खरीदारी के लिए धन्यवाद। ",
      "alreadyWonGift": "आपने इस मोबाइल नंबर पर पहले ही एक गिफ्ट जीता है।",
      "congratulationsYouWon": "बधाई हो! आपने जीता",
      "claimed": "दावा किया",

    },
  },
  mr: {
    "translation": {
      "Continue": "पुढे जा",
      shareText: "मी Gallant स्कॅन करून बक्षीस जिंकलं! 🎁 \nतुम्हीही Gallant खरेदी करा, स्कॅन करा आणि बक्षीस जिंका ",
      Share: "शेअर करा",
      confirmation: "पुष्टी",
      All_products_Scanned: "सर्व उत्पादने स्कॅन केली आहेत ?",
      No: "नाही",
      Yes: "होय",
      invalid_OTP: "अमान्य ओटीपी ",
      resend_OTP: "OTP पुन्हा पाठवा",
      Mega_Draw_Code: "मेगा ड्रॉ कोड",
      Next: "पुढे",
      all_set: "बक्षीस जिंकलं",
      Reward_Won: "बक्षीस जिंकलं",
      Spin_Wheel: "इनामांचे चाक",
      Spin_Wheel_Win: "चाक फिरवा आणि बक्षीस जिंका!",
      go_step2: "पायरी 2 कडे जा",
      Eligible_to_win: "आता तुम्ही जिंकण्यासाठी पात्र आहात",
      Spin_Now: "आत्ता फिरवा",
      Spin_Win: "फिरवा आणि जिंका",
      Product_Serial_Number: "उत्पादनाचा अनुक्रमांक",
      "Done": "पूर्ण",
      "Step_1": "पायरी 1",
      "Step_2": "पायरी 2",
      "Update_Farming": "पायरी 1: शेतीची माहिती अद्ययावत करा",
      "Select_Crop": "पीक निवडा",
      "Soyabean": "सोयाबीन",
      "Ground_Nut": "भुईमूग",
      "Total_acres_this_Season": "या हंगामातील एकूण एकर",
      "Total_acres": "शेतीचे क्षेत्रफळ (एकरमध्ये)",
      "Update": "अपडेट करा",
      "Farming_details_update": "शेतीची माहिती यशस्वीपणे अद्ययावत झाली.",
      "step_2_click": "पायरी 2 कडे जा",
      "Ok": "स्वीकार करना",
      "Click_ok": "कृषी तपशील यशस्वीरित्या अपडेट झाले. पात्रता आणि बक्षीस तपासण्यासाठी OK वर क्लिक करा",
      "Congratulations": "अभिनंदन !!!",
      "claim_gifts": "तुम्ही सर्व सेट आहात! आता, तुमचे बक्षीस क्लेम करा",
      language: "marathi",
      "total_acresErrorMsg": "कृपया एकर प्रविष्ट करा",
      visit: "वाचा",
      Name: "नाव",
      thanks_text: "Corteva Reward (Strongarm) कार्यक्रमात सहभागी झाल्याबद्दल धन्यवाद!",
      eligible_text: "आकर्षक भेटवस्तूंसाठी पात्र ठरण्यासाठी, कृपया सर्व आवश्यक टप्पे पूर्ण करा.",
      Strongarm_Survey: "स्ट्रॉन्गआर्म बक्षीस कार्यक्रम",
      Enter_Details: "माहिती भरा",
      "SelectSteps": "चरण निवडा",
      "termsandconiditionsURL": "http://uat.farmerconnect.in:7000/tracer-microsite/marathi/termsandconditions.php",
      "profileText": "कोर्टेव्हा फार्मर कनेक्ट ॲपमध्ये तुमचे प्रोफाइल तयार होत आहे. कृपया तुमची नोंदणी पूर्ण करा",
      "delegate": "ट्रेसर",
      "nameErrorMsg": "कृपया शेतकऱ्याचे नाव भरा",
      "loginLabel": "मोबाईल नंबर",
      "loginPlaceHolder": "मोबाईल नंबर​",
      "mobileErrorMsg": "कृपया मोबाईल क्रमांक भरा",
      "submitBtn": "सादर करा​",
      "loginBtn": "लॉगिन",
      "otpText": "{mobileNumber} वर OTP एसएमएसद्वारे पाठवला जाईल",
      "otpError": "कृपया वैध ओटीपी भरा",
      "OTPLabel": "OTP",
      "firstName": "पहिलं नाव",
      "firstNameErrorMsg": "कृपया पहिलं नाव प्रविष्ट करा",
      "lastName": "आडनाव",
      "lastNameErrorMsg": "कृपया आडनाव प्रविष्ट करा",
      "pincode": "पिन कोड",
      "address": "पत्ता",
      "done": "पूर्ण",
      "submit": "सबमिट करा",
      "scanTitle": "गॅलंट बाटलीवरील QR कोड स्कॅन करा",
      "scanning": "स्कॅनिंग",
      "scan": "स्कॅन ",
      "rescan": "पुन्हा स्कॅन करा",
      "scanSteps": "QR कोड स्कॅन करण्याचे पायर्या",
      "stepOne": "चरण 1: पाऊचवर QR कोड शोधा",
      "stepTwo": "चरण 2: QR कोड स्कॅन करा आणि सबमिट करा",
      "spinToWin": "प्रविष्ट करा कोर्टेव्हा 'स्कॅन & जिंका",
      "scanProduct": "उत्पाद स्कॅन करा",
      "SpinWheel": "बक्षीस जिंकण्यासाठी चाक फिरवा​",
      "giftcongratulations": "अभिनंदन. आपण जिंकला आहात.​",
      "earned": "आपण रु. 20.00 डेलीगेटसाठी कमावले आहेत",
      "redeemCash": "रोख रक्कम मिळवा​",
      "ClaimReward": "इनामाचा दावा करा",
      "updatesOnReward": "आपण डेलीगेटसह विजेता आहात. इनामाच्या अद्यतनांसाठी आपल्या स्थानिक कॉर्टेवा प्रतिनिधीशी संपर्क साधा",
      "paymentMode": "रक्कम भरण्याची पद्धत निवडा​",
      "bankDetails": "बँक तपशील",
      "accountHolderName": "खातेधारकाचे नाव",
      "accountHolderNameErrorMsg": "खाताधारकाचे नाव आवश्यक आहे",
      "accountNumber": "खाते क्रमांक",
      "accountNumberErrorMsg": "कृपया खात्याचा क्रमांक प्रविष्ट करा",
      "IFSCCode": "IFSC कोड",
      "IFSCCodeErrorMsg": "कृपया IFSC कोड प्रविष्ट करा",
      "confirm": "पुष्टि करा​",
      "UPIErrorMsg": "UPI आवश्यक",
      "transferSuccessText": "आपले रोख हस्तांतरण यशस्वीरित्या झाले​",
      "successSubtitile": "आम्ही आपले पैसे पाठवले आहेत",
      "goHome": "होम पेजकडे जा​",
      "delegateRewards": "ट्रेसर रिवार्ड्स​",
      "claimList": "दाव्यांची यादी",
      "noClaimsFound": "कोणताही दावा सापडला नाही",
      "noSuccessList": "कोणतीही यश यादी सापडली नाही",
      "reclaimList": "रिक्लेम सूचि",
      "noReclaimList": "कोणतीही पुन्हा दावा यादी सापडली नाही",
      "termsAndConditions": "नियम व अटी",
      "privacyPolicy": "गोपनीयता धोरण",
      "agreeText": "सबमिट करून आपण आमच्याशी सहमत आहात",
      "genuityCheck": "प्रामाणिकतेची तपासणी​",
      "genuityProduct": "हे खरे कोर्टेवा उत्पादन आहे",
      "FarmerConnect": "शेतकरी कनेक्टवर जा",
      "UpdateFarmingDetails": "कृषी तपशील अद्यतनित करा",
      "ViewProductInfo": "उत्पादन माहिती पहा आणि शेअर करा",
      "resendOtp": "OTP पुन्हा पाठवा",
      "productName": "उत्पादनः",
      "serialNO": "अनुक्रमांक",
      "alreadyLoginText": "आपला नंबर फार्मर कनेक्ट अॅपमध्ये लॉग इन आहे. लॉग इन करण्यासाठी ठीक आहे दाबा.",
      "notRegisteredText": "आपला नंबर नोंदणीकृत नाही. डेलीगेट धमाका मध्ये भाग घेण्यासाठी कृपया नोंदणी करा.",
      "loginConfirm": "लॉगिन पुष्टी",
      "Alert": "सावधान!",
      "no": "नाही",
      "yes": "होय",
      "OK": "स्वीकारा",
      "amount": "रुपये",
      "Date": "दिनांक",
      "claim": "दाव्य",
      "successList": "यशस्वी सूचि",
      "referenceId": "संदर्भ ID",
      "status": "स्थिती",
      "Scanmore": "आणखी बाटली स्कॅन करा",
      "Rewards": "बक्षीस",
      "reward": "बक्षीस",
      "transfer": "हस्तांतर",
      "home": "मुख्यपृष्ठ",
      "TC": "'नियम व अटी'",
      "ProductInfo": "उत्पादन माहिती",
      "downloadBrochure": "ब्रॉशर डाउनलोड करा",
      "programDetails": "कार्यक्रमाचे तपशील",
      "delegateParticipate": "डेलीगेट दोस्ती धमाका - भाग घ्या",
      "TermsandConditons": "'नियम व अटी'",
      "and": "आणि",
      "BackToHome": "होम पेजकडे जा",
      "ReferenceId": "संदर्भ आयडी",
      "noData": "माहिती उपलब्ध नाही",
      "mblnumberPlaceHolder": "खुदरा विक्रेत्याचा मोबाइल नंबर",
      "name": "नाव",
      "cottn": "कापूस",
      "corn": "मका",
      "enterOTP": "ओटीपी भरा",
      "login": "लॉगइन",
      "scanagain": "पुन्हा स्कॅन करा",
      "Reclaim": "रीक्लेम",
      "cropErrorMsg": "कृपया पिक निवडा​",
      "Skip": "Skip",
      "Claim": "दावा",
      "StepsImage": "एंगेज डबल धमाका - याप्रमाणे सहभागी व्हा",
      sessionExperied: "सत्र संपले आहे. कृपया QR कोड स्कॅन करा.",
      "confirmaccountNumber": "खाते क्रमांकाची पुष्टी करा",
      "confirmaccountNumberErrorMsg": "कृपया खाते क्रमांकाची पुष्टी करा",
      "confirmAccountNumberMismatch": 'खाते क्रमांक पुष्टीकरण खाते क्रमांक जुळत नाही',
      "cortevaInfo": "तुमचे नाव 'Corteva Farmer Connect' अॅपमध्ये जोडले (नोंदणी केले) जात आहे. माहिती भरून तुम्ही कोर्टेवाला परवानगी देता की त्यांनी वेळोवेळी शेती व उत्पादनांशी संबंधित माहितीसाठी तुमच्याशी संपर्क साधावा.",
      "knowmore": "अधिक जाणून घ्या",
      "consentDetailsTitle": "सहमति विवरण",
      "consentDetails": "आपका नाम 'Corteva Farmer Connect' ऐप में पंजीकृत किया जा रहा है।\n\nआप जो व्यक्तिगत जानकारी (नाम, मोबाइल नंबर, फसल विवरण आदि) प्रदान करते हैं, वह Strongarm™ प्रोग्राम और संबंधित सेवाओं के लिए उपयोग की जाएगी।\n\nआप कोर्टेवा एग्रीसाइंस को यह अनुमति देते हैं कि वे समय-समय पर खेती, उत्पादों, ऑफ़र और प्रोग्राम से जुड़ी जानकारी के लिए आपसे कॉल, SMS या WhatsApp के माध्यम से संपर्क कर सकते हैं।\n\nआपकी जानकारी कोर्टेवा की गोपनीयता नीति के अनुसार सुरक्षित रखी जाएगी। आप कभी भी संपर्क करके अपनी सहमति वापस ले सकते हैं।\n\n'सबमिट' बटन पर क्लिक करके, आप उपरोक्त शर्तों से सहमत होते हैं।",
      "ChangeLanguage": "भाषा बदला",
      "consentAgree": "सहमत",
      "consentDecline": "नकार देतो",
      "ShareNow": "आत्ताच शेअर करा",
      "gallant_usedErrorMsg": "कृपया गॅलंट वापरले होते की नाही ते निवडा.",
      "will_buy_strongarm_this_seasonErrorMsg": "कृपया तुम्ही या हंगामात स्ट्राँगआर्म खरेदी केले होते की नाही ते निवडा.",
      "bottleScan": "स्कॅन केलेले एकर",
      "big_prize_opportunity_title": "मोठी बक्षिसे जिंकण्याची संधी",
      "big_prize_opportunity_desc": "जास्त स्कॅन, मोठी बक्षिसे",
      "scan_more": "अधिक स्कॅन करा",
      "scan_more_win_bigger_gifts_title": "अधिक स्कॅन करा, मोठ्या भेटी जिंका!",
      "scan_more_win_bigger_gifts_desc": "प्रत्येक अतिरिक्त स्कॅन तुम्हाला उत्तम बक्षिसांच्या जवळ आणतो.",
      "next_gift_label": "पुढील भेटीसाठी",
      "scan_more_packets_label": "आणखी बाटली स्कॅन करा.",
      "reward_history": "बक्षिसांचा इतिहास",
      "scanned_products": "स्कॅन केलेली उत्पादने",
      "scan_date": "स्कॅनची तारीख",
      "packet_id": "उत्पादनाचे नाव",
      "gift_history": "भेटींचा इतिहास",
      "reward_win_date": "बक्षीस जिंकल्याची तारीख",
      "reward": "बक्षीस",
      "status": "स्थिती",
      "share": "शेअर करा",
      "have_they_used_gallant": "तुम्ही याआधी गॅलेंट वापरले आहे का?",
      "willBuyStrongarmThisSeason": "तुम्ही या हंगामात स्ट्रॉन्गआर्म खरेदी केले होते का?",
      "nextDay": "Next Day",
      "within3Days": "Within 3 Days",
      "after7Days": "After 7 Days",
      "thankYouForPurchase": "तुमच्या खरेदीसाठी धन्यवाद.",
      "alreadyWonGift": "या मोबाईल क्रमांकावर तुम्ही आधीच एक भेटवस्तू जिंकली आहे.",
      "congratulationsYouWon": "अभिनंदन! तुम्ही जिंकलात",
      "claimed": "दावा केला",
    },
  },
  te: {
    "translation": {
      Next: "తదుపరి",
      shareText: "నేను Gallant స్కాన్ చేసి బహుమతి గెలిచా! 🎁 \n మీరూ Gallant కొని, స్కాన్ చేసి బహుమతి గెలవండి",
      Share: "షేర్ చేయండి",
      confirmation: "నిర్ధారణ",
      All_products_Scanned: "అన్ని ఉత్పత్తులు స్కాన్ చేశారా?",
      No: "కాదు",
      Yes: "అవును",
      invalid_OTP: "చెల్లని OTP",
      resend_OTP: "OTP ని మళ్ళీ పంపడానికి",
      Mega_Draw_Code: "మెగా డ్రా కోడ్",
      all_set: "మీరు అంతా సిద్ధంగా ఉన్నారు!",
      Reward_Won: "బహుమతి గెలుచుకున్నారు",
      Spin_Wheel_Win: "చక్రం తిపండి & గెలవండి!",
      Spin_Wheel: "చక్రం తిపండి",
      go_step2: "దశ 2కి వెళ్లండి",
      Eligible_to_win: "మీరు ఇప్పుడు గెలవడానికి అర్హులు",
      Spin_Now: "ఇప్పుడు తిప్పండి",
      Spin_Win: "స్పిన్ చేసి గెలవండి",
      Product_Serial_Number: "ఉత్పత్తి క్రమ సంఖ్య",
      "Done": "పూర్తయింది",
      "Step_1": "దశ 1",
      "Step_2": "దశ 2",
      "Update_Farming": "వ్యవసాయం నవీకరించండి",
      "Select_Crop": "పంట ఎంచుకోండి",
      "Soyabean": "సోయాబీన్",
      "Ground_Nut": "వేరుశనగ",
      "Total_acres_this_Season": "ఈ సీజన్‌లో మొత్తం ఎకరాలు",
      "Total_acres": "మొత్తం ఎకరాలు",
      "Update": "నవీకరణ",
      "Farming_details_update": "వ్యవసాయ వివరాలు విజయవంతంగా నవీకరించబడ్డాయి",
      "step_2_click": "దశ 2కి వెళ్లండి",
      "Ok": "ఓకే",
      "Click_ok": "వ్యవసాయం వివరాలు విజయవంతంగా నవీకరించబడ్డాయి. అర్హత మరియు బహుమతులను పరిశీలించడానికి OK పై క్లిక్ చేయండి.",
      "Congratulations": "అభినందనలు !!!",
      "claim_gifts": "మీరు సర్వం సెట్! ఇప్పుడు, మీ బహుమతులను క్లెయిం చేయండి",
      Name: "పేరు",
      "total_acresErrorMsg": "దయచేసి ఎకరాలు నమోదు చేయండి",
      language: "telugu",
      visit: "చదవండి",
      thanks_text: "కోర్టేవా రివార్డ్ (స్ట్రాంగ్ఆర్మ్) ప్రోగ్రామ్‌లో పాల్గొన్నందుకు ధన్యవాదాలు!",
      eligible_text: "ఆకర్షణీయ బహుమతులకు అర్హత కలగాలంటే, దయచేసి అన్ని తప్పనిసరి దశలను పూర్తిచేయండి.",
      Strongarm_Survey: "స్ట్రాంగ్‌ఆర్మ్ రివార్డ్ ప్రోగ్రామ్",
      Enter_Details: "వివరాలను నమోదు చేయండి",
      "SelectSteps": "దశలు ఎంచుకోండి",
      "termsandconiditionsURL": "http://uat.farmerconnect.in:7000/tracer-microsite/telugu/termsandconditions.php",
      "profileText": "*మీ ప్రొఫైల్  'Corteva Farmer Connect' యాప్‌లో నమోదు చేయబడుతోంది మరియు భవిష్యత్ మార్కెటింగ్ కార్యకలాపాల కోసం మిమ్మల్ని సంప్రదించడానికి మీరు కోర్టెవాకు అధికారం ఇస్తున్నారు.",
      "delegate": "ట్రేసర్",
      "cropErrorMsg": "దయచేసి పంట ఎంచుకోండి​",
      "nameErrorMsg": "దయచేసి మీ పేరు నమోదు చేయండి",
      "Reclaim": "తిరిగి పొందండి",
      "loginLabel": "మొబైల్ నంబర్",
      "loginPlaceHolder": "మొబైల్ నంబర్",
      "mobileErrorMsg": "దయచేసి మొబైల్ నంబర్‌ను నమోదు చేయండి",
      "submitBtn": "సబ్మిట్",
      "loginBtn": "లాగిన్",
      "otpText": "OTP SMS ద్వారా {mobileNumber} కు పంపబడుతుంది",
      "otpError": "దయచేసి చెల్లుబాటయ్యే ఓటీపీ నమోదు చేయండి​",
      "OTPLabel": "OTP",
      "firstName": "మొదటి పేరు",
      "firstNameErrorMsg": "దయచేసి మొదటి పేరు నమోదు చేయండి",
      "lastName": "చివరి పేరు",
      "lastNameErrorMsg": "దయచేసి చివరి పేరు నమోదు చేయండి",
      "pincode": "పిన్ కోడ్",
      "address": "చిరునామా",
      "done": "పూర్తయింది",
      "submit": "సబ్మిట్",
      "scanTitle": "గ్యాలెంట్ బాటిల్ పై QR కోడ్‌ను స్కాన్ చేయండి",
      "scanning": "స్కానింగ్",
      "scan": "స్కాన్ చేయండి",
      "rescan": "మళ్లీ స్కాన్ చేయండి",
      "scanSteps": "QR కోడ్ స్కాన్ చేసే దశలు",
      "stepOne": "దశ 1: పౌచ్‌లో QR కోడ్‌ను కనుగొనండి",
      "stepTwo": "దశ 2: QR కోడ్‌ను స్కాన్ చేసి సమర్పించండి",
      "spinToWin": "బహుమతులు క్లెయిమ్ చేయండి",
      "scanProduct": "ఉత్పత్తి స్కాన్ చేయండి",
      "SpinWheel": "చక్రాన్ని తిప్పండి రివార్డ్‌లను గెలుచుకోవడానికి ",
      "congratulations": "అభినందనలు",
      "giftcongratulations": "అభినందనలు .మీరు విజేత.",
      "earned": "మీరు రూ. 20.00 ట్రేసర్ కోసం సంపాదించారు",
      "redeemCash": "క్యాష్ రెడీమ్ చేయండి",
      "ClaimReward": "మరింత స్కాన్ చేయండి",
      "updatesOnReward": "మీరు ట్రేసర్ తో విజేత. బహుమతి వివరాల కోసం మీ స్థానిక కార్టేవా ప్రతినిధిని సంప్రదించండి",
      "paymentMode": "చెల్లింపు మోడ్ ఎంచుకోండి",
      "bankDetails": "బ్యాంక్ వివరాలు",
      "accountHolderName": "అకౌంట్ పేరు​",
      "accountHolderNameErrorMsg": "అకౌంట్ పేరు అవసరం",
      "accountNumber": "అకౌంట్ నంబర్ ​",
      "accountNumberErrorMsg": "దయచేసి ఖాతా సంఖ్యను నమోదు చేయండి",
      "IFSCCode": "ఐఎఫ్ఎస్ సీ కోడ్ ",
      "IFSCCodeErrorMsg": "దయచేసి IFSC కోడ్‌ను నమోదు చేయండి",
      "confirm": "నిర్థారించండి",
      "UPIErrorMsg": "UPI అవసరం",
      "transferSuccessText": "మీ నగదు బదిలీ విజయవంతమైంది",
      "successSubtitile": "మేము మీకు మీ డబ్బును పంపించాం!",
      "goHome": "మళ్లీ హోం పేజీకి రావడం​",
      "delegateRewards": "రివార్డ్స్",
      "claimList": "క్లెయిమ్ జాబితా",
      "noClaimsFound": "ఏమైనా దావా లభించలేదు",
      "noSuccessList": "ఏమైనా విజయ జాబితా లేదు",
      "reclaimList": "పునః క్లెయిమ్ జాబితా",
      "noReclaimList": "ఏమైనా మళ్లీ దావా జాబితా లేదు",
      "termsAndConditions": "నిబంధనలు మరియు షరతులను",
      "agreeText": "సమర్పించడం ద్వారా మీరు మమ్మల్ని అంగీకరిస్తున్నారు",
      "genuityCheck": "నిజాయితీ తనిఖీ",
      "genuityProduct": "ఇది అసలైన కోర్టేవా ఉత్పత్తి",
      "FarmerConnect": "ఫార్మర్ కనెక్ట్‌కు వెళ్లండి",
      "Continue": "కొనసాగించు",
      "UpdateFarmingDetails": "వ్యవసాయ వివరాలను అప్‌డేట్ చేయండి",
      "ViewProductInfo": "ఉత్పత్తి సమాచారాన్ని వీక్షించండి & భాగస్వామ్యం చేయండి",
      "resendOtp": "OTP మళ్లీ పంపండి",
      "productName": "ఉత్పత్తి",
      "serialNO": "క్రమ సంఖ్య",
      "alreadyLoginText": "మీ నంబర్ కూడా ఫార్మర్ కనెక్ట్ యాప్‌లో లాగిన్ అయ్యింది. లాగిన్ చేయడానికి OK నొక్కండి.",
      "notRegisteredText": "మీ నంబర్ నమోదు కాలేదు. ట్రేసర్ ధమాకాలో పాల్గొనడానికి దయచేసి నమోదు చేసుకోండి.",
      "loginConfirm": "లాగిన్ నిర్ధారణ",
      "Alert": "హెచ్చరిక!",
      "no": "కాదు",
      "yes": "అవును",
      "OK": "సరే",
      "amount": "రూపాయలు",
      "Date": "తేదీ",
      "claim": "దావా",
      "successList": "విజయవంతమైన జాబితా",
      "referenceId": "సందర్భ ID",
      "status": "స్థితి",
      "Scanmore": "మరిన్ని బాటిల్ లను స్కాన్ చేయండి​",
      "Rewards": "రివార్డ్స్ ",
      "reward": "రివార్డ్స్ ",
      "transfer": "బదిలీ చేయండి",
      "home": "హోమ్",
      "TC": "T&C",
      "ProductInfo": "ఉత్పత్తి <br>వివరాలు",
      "downloadBrochure": "బ్రోచర్‌ను <br>డౌన్‌లోడ్ చేయండి",
      "programDetails": "ప్రోగ్రాం వివరాలు",
      "delegateParticipate": "ట్రేసర్ స్నేహధమాకా - పాల్గొనండి",
      "award": "బహుమతి",
      "TermsandConditons": "నిబంధనలు మరియు షరతులు",
      "and": "మరియు",
      "privacyPolicy": "గోప్యతా విధానం",
      "BackToHome": "మళ్లీ హోం పేజీకి రావడం​",
      "ReferenceId": "రిఫరెన్స్ ఐడీ",
      "noData": "డేటా లేదు",
      "mblnumberPlaceHolder": "రిటైలర్ మొబైల్ నంబర్",
      "name": "పేరు",
      "cottn": "పత్తి",
      "corn": "మొక్కజొన్న",
      "enterOTP": "ఓటీపీ నమోదు చేయండి  ",
      "login": "లాగిన్ చేయండి",
      "scanagain": "మళ్లీ స్కాన్ చేయండి",
      "Skip": "Skip",
      "Claim": "దావా",
      "StepsImage": "డబుల్ ధమాకా ప్రతినిధి- ఇలా పాల్గొనండి",
      "sessionExperied": "సెషన్ గడువు ముగిసింది. దయచేసి QR కోడ్‌ని స్కాన్ చేయండి",
      "confirmaccountNumber": "ఖాతా సంఖ్యను నిర్ధారించండి",
      "confirmaccountNumberErrorMsg": "దయచేసి ఖాతా సంఖ్యను నిర్ధారించండి",
      "confirmAccountNumberMismatch": 'ఖాతా సంఖ్య నిర్ధారణ ఖాతా సంఖ్య సరిపోలడం లేద',
      "cortevaInfo": "మీ పేరు 'Corteva Farmer Connect' యాప్‌లో జోడించబడుతోంది (నమోదు చేయబడుతోంది). వివరాలను నమోదు చేయడం ద్వారా, వ్యవసాయం మరియు ఉత్పత్తులకు సంబంధించిన సమాచారం కోసం ఎప్పటికప్పుడు మిమ్మల్ని సంప్రదించడానికి మీరు కోర్టెవాకు అనుమతి ఇస్తున్నారు.",
      selectPayment: {
        cashbackAmountLabel: "క్యాష్‌బ్యాక్ మొత్తం",
        proceedButton: "కొనసాగించు",
        bankDetails: "బ్యాంక్ ఖాతా",
        upi: "యూపీఐ",
      },
      scanProductPage: {
        whatsappHelp: "సహాయం కావాలా? WhatsApp లో సంప్రదించండి",
      },
      "knowmore": "మరింత తెలుసుకోండి",
      "consentDetailsTitle": "सहमति विवरण",
      "consentDetails": "आपका नाम 'Corteva Farmer Connect' ऐप में पंजीकृत किया जा रहा है।\n\nआप जो व्यक्तिगत जानकारी (नाम, मोबाइल नंबर, फसल विवरण आदि) प्रदान करते हैं, वह Strongarm™ प्रोग्राम और संबंधित सेवाओं के लिए उपयोग की जाएगी।\n\nआप कोर्टेवा एग्रीसाइंस को यह अनुमति देते हैं कि वे समय-समय पर खेती, उत्पादों, ऑफ़र और प्रोग्राम से जुड़ी जानकारी के लिए आपसे कॉल, SMS या WhatsApp के माध्यम से संपर्क कर सकते हैं।\n\nआपकी जानकारी कोर्टेवा की गोपनीयता नीति के अनुसार सुरक्षित रखी जाएगी। आप कभी भी संपर्क करके अपनी सहमति वापस ले सकते हैं।\n\n'सबमिट' बटन पर क्लिक करके, आप उपरोक्त शर्तों से सहमत होते हैं।",
      "ChangeLanguage": "భాష మార్చండి",
      "consentAgree": "అంగీకరిస్తున్నాను",
      "consentDecline": "నిరాకరిస్తున్నాను",
      "ShareNow": "ఇప్పుడే షేర్ చేయండి",
      "gallant_usedErrorMsg": "దయచేసి గ్యాలెంట్ ఉపయోగించబడిందో లేదో ఎంచుకోండి.",
      "will_buy_strongarm_this_seasonErrorMsg": "దయచేసి మీరు ఈ సీజన్‌లో స్ట్రాంగ్‌ఆర్మ్‌ను కొనుగోలు చేశారో లేదో ఎంచుకోండి.",
      "bottleScan": "స్కాన్ చేసిన ఎకరాలు",
      "big_prize_opportunity_title": "పెద్ద బహుమతులు గెలుచుకునే అవకాశం",
      "big_prize_opportunity_desc": "ఎక్కువ స్కాన్‌లు, పెద్ద బహుమతులు",
      "scan_more": "మరిన్ని స్కాన్ చేయండి",
      "scan_more_win_bigger_gifts_title": "మరిన్ని స్కాన్ చేయండి, పెద్ద బహుమతులు గెలుచుకోండి!",
      "scan_more_win_bigger_gifts_desc": "ప్రతి అదనపు స్కాన్ మిమ్మల్ని అద్భుతమైన బహుమతులకు దగ్గర చేస్తుంది.",
      "next_gift_label": "తదుపరి బహుమతి కోసం",
      "scan_more_packets_label": "మరిన్ని బాటల్స్ లను స్కాన్ చేయండి.",
      "reward_history": "బహుమతుల చరిత్ర",
      "scanned_products": "స్కాన్ చేసిన ఉత్పత్తులు",
      "scan_date": "స్కాన్ చేసిన తేదీ",
      "packet_id": "ఉత్పత్తి పేరు",
      "gift_history": "బహుమతుల చరిత్ర",
      "reward_win_date": "బహుమతి గెలిచిన తేదీ",
      "reward": "బహుమతి",
      "status": "స్థితి",
      "share": "షేర్ చేయండి",
      "have_they_used_gallant": "మీరు గతంలో గ్యాలెంట్‌ను ఉపయోగించారా?",
      "willBuyStrongarmThisSeason": "ఈ సీజన్‌లో మీరు స్ట్రాంగ్‌ఆర్మ్ కొనుగోలు చేశారా?",
      "nextDay": "Next Day",
      "within3Days": "Within 3 Days",
      "after7Days": "After 7 Days",
      "thankYouForPurchase": "మీ కొనుగోలుకు ధన్యవాదాలు.",
      "alreadyWonGift": "ఈ మొబైల్ నంబర్‌తో మీరు ఇప్పటికే ఒక బహుమతిని గెలుచుకున్నారు.",
      "congratulationsYouWon": "అభినందనలు! మీరు గెలుచుకున్నారు",
      "claimed": "క్లెయిమ్ చేయబడింది",
    },
  },
  kn: {
    "translation": {
      Next: "Next",
      shareText: "I have received a winning Lucky Draw code. Please purchase Strongarm and you can also stand a chance to win.",
      Share: "Share",
      confirmation: "Confirmation",
      All_products_Scanned: "All products Scanned ?",
      No: "No",
      Yes: "Yes",
      invalid_OTP: "Invalid OTP ",
      resend_OTP: "Resend OTP",
      Mega_Draw_Code: "Mega Draw Code",
      Reward_Won: "Reward Won",
      all_set: "You're all set!",
      "Continue": "ಮುಂದುವರೆಸಿ",
      Spin_Wheel_Win: "Spin the Wheel & Win!",
      Spin_Wheel: "Spin Wheel",
      go_step2: "Go to Step 2",
      Eligible_to_win: "You are now Eligible to win",
      Spin_Now: "Spin Now",
      Spin_Win: "Spin and Win",
      Product_Serial_Number: "Product Serial Number",
      "Done": "ಮುಗಿಯಿತು",
      "Step_1": "ಹಂತ 1",
      "Step_2": "ಹಂತ 2",
      "Update_Farming": "ಕೊತ್ತಲು ನವೀಕರಿಸಿ",
      "Select_Crop": "ಹೊಸ ಬೆಳೆ ಆರಿಸಿ",
      "Soyabean": "ಸೋಯಾಬೀನ್",
      "Ground_Nut": "ಭೂಗೋಚಿ",
      "Total_acres_this_Season": "ಈ ಸೀಸನ್‌ನ ಒಟ್ಟು ಎಕರೆಗಳು",
      "Total_acres": "ಒಟ್ಟು ಎಕರೆಗಳು",
      "Update": "ನವೀಕರಿಸು",
      "Farming_details_update": "ಕೃಷಿ ವಿವರಗಳು ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ.",
      "step_2_click": "ಹಂತ 2 ಗಾಗಿ OK ಕ್ಲಿಕ್ ಮಾಡಿ.",
      "Ok": "ಒಕೇ",
      "Click_ok": "ಕೃಷಿ ವಿವರಗಳು ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ. ಅರ್ಹತೆ ಮತ್ತು ಬಹುಮಾನಗಳನ್ನು ಪರಿಶೀಲಿಸಲು OK ಕ್ಲಿಕ್ ಮಾಡಿ.",
      "Congratulations": "ಅಭಿನಂದನೆಗಳು!!!",
      "claim_gifts": "ನೀವು ಎಲ್ಲಾ ಸಿದ್ಧವಾಗಿದ್ದೀರಿ! ಈಗ, ನಿಮ್ಮ ಬಹುಮಾನಗಳನ್ನು క్లೈಮ್ ಮಾಡಿ",
      language: "kannada",
      "total_acresErrorMsg": "ದಯವಿಟ್ಟು ಎಕರೆಗಳನ್ನು ನಮೂದಿಸಿ",
      visit: "Visit",
      Name: "Name",
      Strongarm_Survey: "Strongarm Survey",
      "termsandconiditionsURL": "http://uat.farmerconnect.in:7000/tracer-microsite/kannada/termsandconditions.php",
      "profileText": "*ನಿಮ್ಮ ಪ್ರೊಫೈಲ್ ಅನ್ನು 'Corteva Farmer Connect' ಅಪ್ಲಿಕೇಶನ್‌ನಲ್ಲಿ ನೋಂದಾಯಿಸಲಾಗುತ್ತಿದೆ ಮತ್ತು ಭವಿಷ್ಯದ ಮಾರ್ಕೆಟಿಂಗ್ ಚಟುವಟಿಕೆಗಳಿಗಾಗಿ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಲು ನೀವು ಕಾರ್ಟೆವಾಗೆ ಅಧಿಕಾರ ನೀಡುತ್ತೀರಿ.",
      "delegate": "ಟ್ರೇಸರ್",
      "cropErrorMsg": "ದಯವಿಟ್ಟು ಬೆಳೆ ಆಯ್ಕೆ ಮಾಡಿ",
      "nameErrorMsg": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
      "Reclaim": "ಹಿಂಪಡೆಯಿರಿ",
      "loginLabel": "ಮೊಬೈಲ್ ನಂಬರ್",
      "loginPlaceHolder": "ಮೊಬೈಲ್ ನಂಬರ್",
      "mobileErrorMsg": "ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ ಮೊಬೈಲ್ ನಂಬರ್ ನಮೂದಿಸಿ",
      "submitBtn": "ಸಲ್ಲಿಸಿ",
      "loginBtn": "ಲಾಗಿನ್",
      "otpText": "OTP {mobileNumber} ಗೆ SMS ಮೂಲಕ ಕಳುಹಿಸಲಾಗುತ್ತದೆ",
      "otpError": "ದಯವಿಟ್ಟು ಮಾನ್ಯ ಒಟಿಪಿ ನಮೂದಿಸಿ​",
      "OTPLabel": "OTP",
      "firstName": "ಮೊದಲ ಹೆಸರು",
      "firstNameErrorMsg": "ದಯವಿಟ್ಟು ಮೊದಲ ಹೆಸರು ನಮೂದಿಸಿ",
      "lastName": "ಕೊನೆಯ ಹೆಸರು",
      "lastNameErrorMsg": "ದಯವಿಟ್ಟು ಕೊನೆಯ ಹೆಸರು ನಮೂದಿಸಿ",
      "pincode": "ಪಿನ್ ಕೋಡ್",
      "address": "ವಿಳಾಸ",
      "done": "ಮುಗಿಯಿತು",
      "submit": "ಸಲ್ಲಿಸಿ",
      "scanTitle": "ಬಾಟಲಿಯ ಮೇಲೆ ಕ್ಯು ಆರ್ ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ​",
      "scanning": "ಸ್ಕ್ಯಾನಿಂಗ್",
      "scan": "ಸ್ಕ್ಯಾನ್",
      "rescan": "ಮತ್ತೊಮ್ಮೆಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಿರಿ",
      "scanSteps": "QR ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡುವ ಹಂತಗಳು",
      "stepOne": "ಹಂತ 1: ಪೌಚ್‌ನಲ್ಲಿ QR ಕೋಡ್ ಅನ್ನು ಹುಡುಕಿ",
      "stepTwo": "ಹಂತ 2: QR ಕೋಡ್ ಅನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ ಮತ್ತು ಸಲ್ಲಿಸಿ",
      "spinToWin": "ಪ್ರಶಸ್ತಿ_claim ಮಾಡಿ​",
      "scanProduct": "ಉತ್ಪನ್ನವನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
      "SpinWheel": "ಬಹುಮಾನಗಳನ್ನು ಗೆಲ್ಲಲು ಚಕ್ರವನ್ನು ತಿರುಗಿಸಿ​",
      "congratulations": "ಅಭಿನಂದನೆಗಳು",
      "giftcongratulations": "ಅಭಿನಂದನೆ. ನೀವು ವಿಜಯಿಯಾಗಿದ್ದೀರಿ​",
      "earned": "ನೀವು ರೂ. ಗಳಿಸಿದ್ದಾರೆ. ಟ್ರೇಸರ್ ಗಾಗಿ 20.00 ನಗದು",
      "redeemCash": "ನಗದು ರೆಡೀಮ್ ಮಾಡಿಕೊಳ್ಳಿ​",
      "ClaimReward": "ಬಹುಮಾನವನ್ನು ಪಡೆಯಿರಿ",
      "updatesOnReward": "ನೀವು ಟ್ರೇಸರ್ ನೊಂದಿಗೆ ವಿಜೇತ. ಬಹುಮಾನದ ವಿವರಗಳಿಗಾಗಿ ನಿಮ್ಮ ಸ್ಥಳೀಯ ಕಾರ್ಟೇವಾ ಪ್ರತಿನಿಧಿಯನ್ನು ಸಂಪರ್ಕಿಸಿ",
      "paymentMode": "ಪಾವತಿ ವಿಧ ಆಯ್ಕೆ ಮಾಡಿ​",
      "bankDetails": "ಬ್ಯಾಂಕ್ ವಿವರಗಳು",
      "accountHolderName": "ಖಾತೆ ಹೆಸರು",
      "accountHolderNameErrorMsg": "ಖಾತೆಧಾರಕನ ಹೆಸರು ಅಗತ್ಯವಿದೆ",
      "accountNumber": "ಖಾತೆ ಸಂಖ್ಯೆ",
      "accountNumberErrorMsg": "ದಯವಿಟ್ಟು ಖಾತೆ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
      "IFSCCode": "IFSC ಕೋಡ್",
      "IFSCCodeErrorMsg": "ದಯವಿಟ್ಟು IFSC ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ",
      "confirm": "ದೃಢೀಕರಿಸಿ",
      "UPIErrorMsg": "UPI ಅಗತ್ಯವಿದೆ",
      "transferSuccessText": "ನಿಮ್ಮ ನಗದು ವರ್ಗಾವಣೆ ಯಶಸ್ವಿಯಾಗಿದೆ​",
      "successSubtitile": "ನಾವು ನಿಮ್ಮ ಹಣವನ್ನು ಕಳುಹಿಸಿದ್ದೇವೆ!",
      "goHome": "ಹೋಂ ಗೆ ಹೋಗಿ​",
      "delegateRewards": "ಟ್ರೇಸರ್ ರಿವಾರ್ಡ್ಸ್​",
      "claimList": "ಕ್ಲೈಮ್ ಪಟ್ಟಿ​",
      "noClaimsFound": "ಯಾವುದೇ ದಾವಾ ಕಂಡುಬಂದಿಲ್ಲ",
      "noSuccessList": "ಯಾವುದೇ ಯಶಸ್ಸಿನ ಪಟ್ಟಿ ಲಭ್ಯವಿಲ್ಲ",
      "reclaimList": "ರೀಕ್ಲೈಮ್ ಪಟ್ಟಿ​",
      "noReclaimList": "ಯಾವುದೇ ಮರುದಾವಾ ಪಟ್ಟಿ ಲಭ್ಯವಿಲ್ಲ",
      "agreeText": "ಸಲ್ಲಿಸುವ ಮೂಲಕ ನೀವು ನಮ್ಮೊಂದಿಗೆ ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೀರಿ",
      "genuityCheck": "ಉತ್ಪನ್ನದ ಪ್ರಮಾಣೀಕರಣ ಪರೀಕ್ಷೆ​",
      "resendOtp": "OTP ಮರುಕಳುಹಿಸಿ",
      "productName": "ಉತ್ಪನ್ನ",
      "serialNO": "ಕ್ರಮ ಸಂಖ್ಯೆ​",
      "alreadyLoginText": "ನಿಮ್ಮ ಸಂಖ್ಯೆ ಫಾರ್ಮರ್ ಕನೆಕ್ಟ್ ಆಪ್‌ನಲ್ಲಿ ಲಾಗಿನ್ ಆಗಿದೆ. ಲಾಗಿನ್ ಮಾಡಲು OK ಒತ್ತಿ.",
      "notRegisteredText": "ನಿಮ್ಮ ಸಂಖ್ಯೆ ನೋಂದಾಯಿಸಲ್ಪಡಿಲ್ಲ. ದಯವಿಟ್ಟು ಟ್ರೇಸರ್ ಧಮಾಕಾದಲ್ಲಿ ಪಾಲ್ಗೊಳ್ಳಲು ನೋಂದಾಯಿಸು.",
      "loginConfirm": "ಲಾಗಿನ್ ದೃಢೀಕರಣ",
      "Alert": "ಎಚ್ಚರಿಕೆ!",
      "no": "ಇಲ್ಲ",
      "yes": "ಹೌದು",
      "OK": "ಸರಿ",
      "amount": "ರೂ",
      "Date": "ದಿನಾಂಕ",
      "claim": "ದಾವಾ",
      "successList": "ಯಶಸ್ಸಿನ ಪಟ್ಟಿ​",
      "referenceId": "ಉಲ್ಲೇಖ ಐಡಿ​",
      "status": "ಸ್ಥಿತಿ",
      "Scanmore": "ಮತ್ತಷ್ಟು ಸ್ಕ್ಯಾನ್ ಮಾಡಿ​",
      "Rewards": "ರಿವಾರ್ಡ್ಸ್",
      "reward": "ರಿವಾರ್ಡ್ಸ್",
      "transfer": "ವರ್ಗಾವಣೆ",
      "home": "ಮುಖಪುಟ",
      "TC": "T&C",
      "ProductInfo": "ಉತ್ಪನ್ನ <br>ವಿವರಗಳು",
      "downloadBrochure": "ಬ್ರೋಶರ್ ಅನ್ನು <br>ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
      "programDetails": "ಕಾರ್ಯಕ್ರಮದ ವಿವರಗಳು",
      "delegateParticipate": "ಟ್ರೇಸರ್ “ಡಬಲ್ ಧಮಾಕಾದಲ್ಲಿ” ಪಾಲ್ಗೊಳ್ಳಿ",
      "termsAndConditions": "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
      "award": "ಬಹುಮಾನ",
      "TermsandConditons": "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
      "and": "ಮತ್ತು",
      "privacyPolicy": "ಗೌಪ್ಯತಾ ನೀತಿ",
      "BackToHome": "ಪುನಃ ಹೋಂ ಪುಟಕ್ಕೆ​",
      "ReferenceId": "ಉಲ್ಲೇಖ ಐಡಿ",
      "noData": "ಯಾವುದೇ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ",
      "mblnumberPlaceHolder": "ರೆಟೈಲರ್ ಮೊಬೈಲ್ ನಂಬರ್",
      "name": "ಹೆಸರು",
      "cottn": "ಹತ್ತಿ",
      "corn": "ಮೆಕ್ಕೆಜೋಳ",
      "enterOTP": "ಒಟಿಪಿ ನಮೂದಿಸಿ",
      "login": "ಲಾಗಿನ್",
      "scanagain": "ಮತ್ತೆ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
      "Skip": "Skip",
      "Claim": "ಕ್ಲೈಮ್",
      "StepsImage": "ಎಂಗೇಜ್ ಡಬಲ್ ಧಮಾಕಾ- ಹೀಗೆ ಪಾಲ್ಗೊಳ್ಳಿ",
      "sessionExperied": "ಅಧಿವೇಶನ ಮುಕ್ತಾಯವಾಗಿದೆ. ದಯವಿಟ್ಟು QR ಕೋಡ್ ಅನ್ನುಸ್ಕ್ಯಾನ್ ಮಾಡಿ.",
      "confirmaccountNumber": "ಖಾತೆ ಸಂಖ್ಯೆಯನ್ನು ದೃಢೀಕರಿಸಿ",
      "confirmaccountNumberErrorMsg": "ದಯವಿಟ್ಟು ಖಾತೆ ಸಂಖ್ಯೆಯನ್ನು ದೃಢೀಕರಿಸಿ ನಮೂದಿಸಿ",
      "confirmAccountNumberMismatch": 'ಖಾತೆ ಸಂಖ್ಯೆ ದೃಢೀಕರಣ ಖಾತೆ ಸಂಖ್ಯೆ ಹೊಂದಿಕೆಯಾಗುತ್ತಿಲ್ಲ',
      "cortevaInfo": "ನಿಮ್ಮ ಹೆಸರನ್ನು 'Corteva Farmer Connect' ಆಪ್‌ನಲ್ಲಿ ನೋಂದಾಯಿಸಲಾಗುತ್ತಿದೆ. ಮಾಹಿತಿಯನ್ನು ಭರ್ತಿ ಮಾಡುವ ಮೂಲಕ, ಕೃಷಿ ಮತ್ತು ಉತ್ಪನ್ನಗಳಿಗೆ ಸಂಬಂಧಿಸಿದ ಮಾಹಿತಿಗಾಗಿ ಕಾಲಕಾಲಕ್ಕೆ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಲು ಕೋರ್ಟೇವಾಗೆ ನೀವು ಅನುಮತಿ ನೀಡುತ್ತೀರಿ.",
      selectPayment: {
        cashbackAmountLabel: "ಕ್ಯಾಶ್‌ಬ್ಯಾಕ್ ಮೊತ್ತ",
        proceedButton: "ಮುಂದುವರಿಸಿ",
        bankDetails: "ಬ್ಯಾಂಕ್ ಖಾತೆ",
        upi: "ಯೂಪಿಐ",
      },
      scanProductPage: {
        whatsappHelp: "ಸಹಾಯ ಬೇಕೇ? WhatsApp ನಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ",
      },
      "knowmore": "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
      "consentDetailsTitle": "सहमति विवरण",
      "consentDetails": "आपका नाम 'Corteva Farmer Connect' ऐप में पंजीकृत किया जा रहा है।\n\nआप जो व्यक्तिगत जानकारी (नाम, मोबाइल नंबर, फसल विवरण आदि) प्रदान करते हैं, वह Strongarm™ प्रोग्राम और संबंधित सेवाओं के लिए उपयोग की जाएगी।\n\nआप कोरटेवा एग्रीसाइंस को यह अनुमति देते हैं कि वे समय-समय पर खेती, उत्पादों, ऑफ़र और प्रोग्राम से जुड़ी जानकारी के लिए आपसे कॉल, SMS या WhatsApp के माध्यम से संपर्क कर सकते हैं।\n\nआपकी जानकारी कोर्टेवा की गोपनीयता नीति के अनुसार सुरक्षित रखी जाएगी। आप कभी भी संपर्क करके अपनी सहमति वापस ले सकते हैं।\n\n'सबमिट' बटन पर क्लिक करके, आप उपरोक्त शर्तों से सहमत होते हैं।",
      "ChangeLanguage": "ಭಾಷೆ ಬದಲಾಯಿಸಿ",
      "consentAgree": "ಒಪ್ಪುತ್ತೇನೆ",
      "consentDecline": "ನಿರಾಕರಿಸುತ್ತೇನೆ",
      "ShareNow": "ಈಗಲೇ ಹಂಚಿಕೊಳ್ಳಿ",
      "gallant_usedErrorMsg": "Please select whether Gallant was used.",
      "will_buy_strongarm_this_seasonErrorMsg": "Please select when Strongarm will be purchased.",
      "bottleScan": "बोतल स्कैन किए",
      "big_prize_opportunity_title": "बड़े इनाम जीतने का मौका",
      "big_prize_opportunity_desc": "ज़्यादा स्कैन, बड़े इनाम",
      "scan_more": "और स्कैन करें",
      "scan_more_win_bigger_gifts_title": "और स्कैन करें, बड़े उपहार जीतें!",
      "scan_more_win_bigger_gifts_desc": "हर अतिरिक्त स्कैन आपको शानदार पुरस्कारों के करीब लाता है।",
      "next_gift_label": "अगले उपहार के लिए",
      "scan_more_packets_label": "और बोतल स्कैन करें।",
      "reward_history": "Reward History",
      "scanned_products": "स्कैन किए गए उत्पाद",
      "scan_date": "स्कैन की तारीख",
      "packet_id": "बोतल आईडी",
      "gift_history": "उपहारों का इतिहास",
      "reward_win_date": "पुरस्कार जीतने की तारीख",
      "reward": "पुरस्कार",
      "status": "स्थिति",
      "share": "शेयर करें",
      "have_they_used_gallant": "Have they used Gallant in the past?"
    },
  },
  pa: {
    "translation": {
      Mega_Draw_Code: "Mega Draw Code",
      shareText: "I have received a winning Lucky Draw code. Please purchase Strongarm and you can also stand a chance to win.",
      Share: "Share",
      confirmation: "Confirmation",
      All_products_Scanned: "All products Scanned ?",
      No: "No",
      Yes: "Yes",
      invalid_OTP: "Invalid OTP ",
      resend_OTP: "Resend OTP",
      Next: "Next",
      go_step2: "Go to Step 2",
      all_set: "You're all set!",
      Reward_Won: "Reward Won",
      Spin_Wheel_Win: "Spin the Wheel & Win!",
      Spin_Wheel: "Spin Wheel",
      language: "english",
      Eligible_to_win: "You are now Eligible to win",
      Spin_Now: "Spin Now",
      Spin_Win: "Spin and Win",
      Product_Serial_Number: "Product Serial Number",
      total_acresErrorMsg: "Please enter acres",
      visit: "Visit",
      Name: "Name",
      Strongarm_Survey: "Strongarm Survey",
      "termsandconiditionsURL": "http://uat.farmerconnect.in:7000/tracer-microsite/punjabi/termsandconditions.php",
      "profileText": "ਤੁਹਾਡੀ ਪ੍ਰੋਫਾਈਲ ਕੋਰਟੇਵਾ ਫਾਰਮਰ ਕਨੈਕਟ ਐਪ ਵਿੱਚ ਬਣਾਈ ਜਾ ਰਹੀ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀ ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਨੂੰ ਪੂਰਾ ਕਰੋ",
      "delegate": "ਟ੍ਰੇਸਰ",
      "cropErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਫ਼ਸਲ ਚੁਣੋ​​",
      "nameErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਨਾਮ ਦਰਜ ਕਰੋ",
      "Reclaim": "ਪਿੱਛੇ ਹੋਵੋ",
      "loginLabel": "ਮੋਬਾਈਲ ਨੰਬਰ",
      "loginPlaceHolder": "ਮੋਬਾਈਲ ਨੰਬਰ",
      "mobileErrorMsg": "ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ ਅਤੇ 'ਸਬਮਿਟ' ਬਟਨ 'ਤੇ ਕਲਿਕ ਕਰੋ।",
      "submitBtn": "ਜਮ੍ਹਾਂ ਕਰੋ ",
      "loginBtn": "ਲਾੱਗਇਨ ਕਰੋ ​",
      "otpText": "OTP SMS ਰਾਹੀਂ {mobileNumber} 'ਤੇ ਭੇਜਿਆ ਜਾਵੇਗਾ",
      "otpError": "ਕਿਰਪਾ ਕਰਕੇ ਵੈਧ ਓਟੀਪੀ ਦਾਖਲ ਕਰੋ ​",
      "OTPLabel": "OTP",
      "firstName": "ਪਹਿਲਾ ਨਾਂ",
      "firstNameErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾ ਨਾਮ ਦਰਜ ਕਰੋ",
      "lastName": "ਆਖਰੀ ਨਾਂਮ",
      "lastNameErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਆਖਰੀ ਨਾਮ ਦਰਜ ਕਰੋ",
      "pincode": "ਪਿੰਨ ਕੋਡ",
      "address": "ਪਤਾ",
      "done": "ਪੂਰਾ ਕੀਤਾ",
      "submit": "ਜਮ੍ਹਾਂ ਕਰੋ",
      "scanTitle": "ਬੋਤਲ ਦਾ QR ਕੋਡ ਸਕੈਨ ਕਰੋ ​",
      "scanning": "ਸਕੈਨਿੰਗ",
      "scan": "ਸਕੈਨ ਕਰੋ ​",
      "rescan": "ਹੋਰ ਸਕੈਨ ਕਰੋ ​",
      "scanSteps": "QR ਕੋਡ ਨੂੰ ਸਕੈਨ ਕਰਨ ਲਈ ਕਦਮ",
      "stepOne": "ਕਦਮ 1: ਪਾਊਚ ਵਿੱਚ QR ਕੋਡ ਲੱਭੋ",
      "stepTwo": "ਕਦਮ 2: ਸਕੈਨ ਕਰੋ ਅਤੇ QR ਕੋਡ ਦਰਜ ਕਰੋ",
      "spinToWin": "ਇਨਾਮ ਜਿੱਤਣ ਲਈ ਦਾਖਲ ਹੋਵੋ ​",
      "scanProduct": "ਉਤਪਾਦ ਨੂੰ ਸਕੈਨ ਕਰੋ",
      "SpinWheel": "ਇਨਾਮ ਜਿੱਤਣ ਲਈ ਪਹੀਆ ਘੁਮਾਓ",
      "congratulations": "ਵਧਾਈਆਂ",
      "giftcongratulations": "ਵਧਾਈ ਹੋਵੇ। ਤੁਸੀਂ ਜੇਤੂ ਹੋ।",
      "earned": "ਤੁਹਾਨੂੰ ਰੁ. ਟ੍ਰੇਸਰ ਲਈ 20.00 ਕਮਾਏ",
      "redeemCash": "ਨਕਦ ਭੁਗਤਾਨ ਪ੍ਰਾਪਤ ਕਰੋ​",
      "ClaimReward": "ਹੋਰ ਸਕੈਨ ਕਰੋ ​",
      "updatesOnReward": "ਤੁਸੀਂ ਟ੍ਰੇਸਰ ਦੇ ਨਾਲ ਜੇਤੂ ਹੋ। ਤੋਹਫ਼ੇ ਦੇ ਵੇਰਵਿਆਂ ਲਈ ਆਪਣੇ ਸਥਾਨਕ ਕਾਰਟੇਵਾ ਪ੍ਰਤੀਨਿਧੀ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
      "paymentMode": "ਪੇਮੈਂਟ ਮੋਡ ਚੁਣੋ​",
      "bankDetails": "ਬੈਂਕ ਵੇਰਵੇ",
      "accountHolderName": "ਖਾਤਾ ਧਾਰਕ ਦਾ ਨਾਮ​",
      "accountHolderNameErrorMsg": "ਖਾਤੇ ਦਾ ਨਾਮ ਲੋੜੀਂਦਾ ਹੈ",
      "accountNumber": "ਅਕਾਊਂਟ ਨੰਬਰ​​",
      "accountNumberErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਖਾਤਾ ਨੰਬਰ ਦਾਖਲ ਕਰੋ",
      "IFSCCode": "IFSC ਕੋਡ",
      "IFSCCodeErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ IFSC ਕੋਡ ਦਾਖਲ ਕਰੋ",
      "confirm": "ਪੁਸ਼ਟੀ ਕਰੋ ",
      "UPIErrorMsg": "UPI ਦੀ ਲੋੜ ਹੈ",
      "transferSuccessText": "ਤੁਹਾਡਾ ਨਕਦ ਟ੍ਰਾਂਸਫਰ ਸਫਲ ਰਿਹਾ​",
      "successSubtitile": "ਅਸੀਂ ਤੁਹਾਡੇ ਪੈਸੇ ਭੇਜ ਦਿੱਤੇ ਹਨ",
      "goHome": "ਹੋਮ ਪੇਜ 'ਤੇ ਜਾਓ​​",
      "delegateRewards": "ਟ੍ਰੇਸਰ ਰਿਵਾਰਡ",
      "claimList": "ਦਾਅਵਾ ਸੂਚੀ",
      "noClaimsFound": "ਕੋਈ ਦਾਅਵੇ ਨਹੀਂ ਮਿਲੇ",
      "noSuccessList": "ਕੋਈ ਜਿੱਤ ਸੂਚੀ ਹੈ",
      "reclaimList": "ਰਿਕਲੇਮ ਸੂਚੀ ​",
      "noReclaimList": "ਫਿਰ ਵੀ ਕੋਈ ਦਾਅਵਾ ਸੂਚੀ ਨਹੀਂ",
      "privacyPolicy": "ਪਰਾਈਵੇਟ ਨੀਤੀ",
      "agreeText": "ਦਰਜ ਕਰਕੇ ਤੁਸੀਂ ਸਾਡੇ ਨਾਲ ਸਹਿਮਤ ਹੋ",
      "genuityCheck": "ਉਤਪਾਦ ਪ੍ਰਮਾਣਿਕਤਾ ਦੀ ਜਾਂਚ",
      "resendOtp": "OTP ਦੁਬਾਰਾ ਭੇਜੋ",
      "productName": "ਉਤਪਾਦ",
      "serialNO": "ਲੜੀ ਸੰਖਿਆ ",
      "alreadyLoginText": "ਤੁਹਾਡਾ ਨੰਬਰ ਫਾਰਮਰ ਕਨੈਕਟ ਐਪ ਵਿੱਚ ਵੀ ਲੌਗਇਨ ਹੈ। ਲੌਗ ਇਨ ਕਰਨ ਲਈ ਠੀਕ 'ਤੇ ਟੈਪ ਕਰੋ।",
      "notRegisteredText": "ਤੁਹਾਡਾ ਨੰਬਰ ਰਜਿਸਟਰਡ ਨਹੀਂ ਸੀ। ਕਿਰਪਾ ਕਰਕੇ ਟ੍ਰੇਸਰ ਧਮਾਕੇ ਵਿੱਚ ਹਿੱਸਾ ਲੈਣ ਲਈ ਰਜਿਸਟਰ ਕਰੋ।",
      "loginConfirm": "ਲਾਗਇਨ ਪੁਸ਼ਟੀ",
      "Alert": "ਚੇਤਾਵਨੀ!",
      "no": "ਨਹੀਂ",
      "yes": "ਹਾਂ",
      "OK": "ਠੀਕ ਹੈ",
      "amount": "ਰੁਪਏ",
      "Date": "ਮਿਤੀ",
      "claim": "ਕਲੇਮ",
      "successList": "ਸਫਲਤਾ ਸੂਚੀ​",
      "referenceId": "ਰੇਫ਼ਰੇਂਸ ਆਈ.ਡੀ​",
      "status": "ਸਥਿਤੀ",
      "Scanmore": "ਹੋਰ ਸਕੈਨ ਕਰੋ",
      "Rewards": "ਇਨਾਮ",
      "reward": "ਇਨਾਮ",
      "transfer": "ਟ੍ਰਾਂਸਫ਼ਰ ਕਰੋ​",
      "home": "ਘਰ",
      "TC": "T&C",
      "ProductInfo": "ਉਤਪਾਦ <br>ਵਿਵਰਾਲੁ",
      "downloadBrochure": "ਬਰੋਸ਼ਰ ਡਾਊਨਲੋਡ ਕਰੋ<br>",
      "programDetails": "ਪ੍ਰੋਗਰਾਮ ਦੇ ਵੇਰਵੇ",
      "delegateParticipate": "ਟ੍ਰੇਸਰ ਦੋਸਤੀ - ਹਿੱਸਾ ਲਓ",
      "termsAndConditions": "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
      "award": "ਉਪਹਾਰ",
      "TermsandConditons": "ਨਿਬੰਧਨ ਅਤੇ ਸ਼ਰਤਾਂ",
      "and": "ਅਤੇ",
      "BackToHome": "ਹੋਮ ਪੇਜ 'ਤੇ ਵਾਪਸ ਜਾਓ​",
      "ReferenceId": "ਰੈਫਰੈਂਸ ਆਈਡੀ ​",
      "noData": "ਕੋਈ ਡਾਟਾ ਨਹੀਂ",
      "mblnumberPlaceHolder": "ਰਿਟੇਲਰ ਦਾ ਮੋਬਾਈਲ ਨੰਬਰ",
      "name": "ਨਾਂਅ",
      "cottn": "ਕਪਾਸ",
      "corn": "ਮੱਕਾ",
      "enterOTP": "ਓਟੀਪੀ ਦਾਖਲ ਕਰੋ",
      "login": "ਲਾੱਗਇਨ ਕਰੋ",
      "scanagain": "ਹੋਰ ਸਕੈਨ ਕਰੋ ​",
      "Skip": "Skip",
      "Claim": "ਕਲੇਮ",
      "StepsImage": "ਡੇਲੀਗੇਟ ਡਬਲ ਧਮਾਕਾ-ਇਵੇਂ ਭਾਗ ਲਵੋ",
      "sessionExperied": "ਸੈਸ਼ਨ ਖਤਮ ਹੋ ਗਿਆ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ QR ਕੋਡ ਸਕੈਨ ਕਰੋ।",
      "confirmaccountNumber": "ಖಾತೆ ಸಂಖ್ಯೆಯನ್ನು ದೃಢೀಕರಿಸಿ",
      "confirmaccountNumberErrorMsg": "ਕਿਰਪਾ ਕਰਕੇ ਪੁਸ਼ਟੀ ਖਾਤਾ ਨੰਬਰ ਦਰਜ ਕਰੋ",
      "confirmAccountNumberMismatch": 'ਖਾਤਾ ਨੰਬਰ ਪੁਸ਼ਟੀਕਰਨ ਖਾਤਾ ਨੰਬਰ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ',
      "cortevaInfo": "ਤੁਹਾਡਾ ਨਾਮ 'Corteva Farmer Connect' ਐਪ ਵਿੱਚ ਰਜਿਸਟਰ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ। ਜਾਣਕਾਰੀ ਭਰ ਕੇ ਤੁਸੀਂ ਕੋਰਟੇਵਾ ਨੂੰ ਖੇਤੀਬਾੜੀ ਅਤੇ ਉਤਪਾਦਾਂ ਨਾਲ ਸੰਬੰਧਿਤ ਜਾਣਕਾਰੀ ਲਈ ਸਮੇਂ-ਸਮੇਂ ਤੇ ਤੁਹਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰਨ ਦੀ ਆਗਿਆ ਦਿੰਦੇ ਹੋ।",
      selectPayment: {
        cashbackAmountLabel: "ਕੈਸ਼ਬੈਕ ਰਕਮ",
        proceedButton: "ਅੱਗੇ ਵਧੋ",
        bankDetails: "ਬੈਂਕ ਖਾਤਾ",
        upi: "ਯੂਪੀਆਈ",
      },
      scanProductPage: {
        whatsappHelp: "ਮਦਦ ਚਾਹੀਦੀ ਹੈ? WhatsApp 'ਤੇ ਸੰਪਰਕ ਕਰੋ",
      },
      "knowmore": "ਹੋਰ ਜਾਣੋ",
      "consentDetailsTitle": "सहमति विवरण",
      "consentDetails": "आपका नाम 'Corteva Farmer Connect' ऐप में पंजीकृत किया जा रहा है।\n\nआप जो व्यक्तिगत जानकारी (नाम, मोबाइल नंबर, फसल विवरण आदि) प्रदान करते हैं, वह Strongarm™ प्रोग्राम और संबंधित सेवाओं के लिए उपयोग की जाएगी।\n\nआप कोर्टेवा एग्रीसाइंस को यह अनुमति देते हैं कि वे समय-समय पर खेती, उत्पादों, ऑफ़र और प्रोग्राम से जुड़ी जानकारी के लिए आपसे कॉल, SMS या WhatsApp के माध्यम से संपर्क कर सकते हैं।\n\nआपकी जानकारी कोर्टेवा की गोपनीयता नीति के अनुसार सुरक्षित रखी जाएगी। आप कभी भी संपर्क करके अपनी सहमति वापस ले सकते हैं।\n\n'सबमिट' बटन पर क्लिक करके, आप उपरोक्त शर्तों से सहमत होते हैं।",
      "ChangeLanguage": "ਭਾਸ਼ਾ ਬਦਲੋ",
      "consentAgree": "ਸਹਿਮਤ ਹਾਂ",
      "consentDecline": "ਅਸਵੀਕਾਰ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ",
      "ShareNow": "ਹੁਣੇ ਹੀ ਸਾਂਝਾ ਕਰੋ",
      "gallant_usedErrorMsg": "Please select whether Gallant was used.",
      "will_buy_strongarm_this_seasonErrorMsg": "Please select when Strongarm will be purchased.",
      "bottleScan": "बोतल स्कैन किए",
      "big_prize_opportunity_title": "बड़े इनाम जीतने का मौका",
      "big_prize_opportunity_desc": "ज़्यादा स्कैन, बड़े इनाम",
      "scan_more": "और स्कैन करें",
      "scan_more_win_bigger_gifts_title": "और स्कैन करें, बड़े उपहार जीतें!",
      "scan_more_win_bigger_gifts_desc": "हर अतिरिक्त स्कैन आपको शानदार पुरस्कारों के करीब लाता है।",
      "next_gift_label": "अगले उपहार के लिए",
      "scan_more_packets_label": "और बोतल स्कैन करें।",
      "reward_history": "Reward History",
      "scanned_products": "स्कैन किए गए उत्पाद",
      "scan_date": "स्कैन की तारीख",
      "packet_id": "बोतल आईडी",
      "gift_history": "उपहारों का इतिहास",
      "reward_win_date": "पुरस्कार जीतने की तारीख",
      "reward": "पुरस्कार",
      "status": "स्थिति",
      "share": "शेयर करें",
      "have_they_used_gallant": "Have they used Gallant in the past?"
    },
  },
  gu: {
    "translation": {
      Next: "Next",
      shareText: "I have received a winning Lucky Draw code. Please purchase Strongarm and you can also stand a chance to win.",
      Share: "Share",
      confirmation: "Confirmation",
      All_products_Scanned: "All products Scanned ?",
      No: "No",
      Yes: "Yes",
      invalid_OTP: "Invalid OTP ",
      resend_OTP: "Resend OTP",
      Mega_Draw_Code: "Mega Draw Code",
      Reward_Won: "Reward Won",
      all_set: "You're all set!",
      go_step2: "Go to Step 2",
      Spin_Wheel_Win: "Spin the Wheel & Win!",
      Spin_Wheel: "Spin Wheel",
      "Continue": "જારી રાખો",
      Eligible_to_win: "You are now Eligible to win",
      Spin_Now: "Spin Now",
      Spin_Win: "Spin and Win",
      Product_Serial_Number: "Product Serial Number",
      "Done": "પુરું",
      "Step_1": "કદમ 1",
      "Step_2": "કદમ 2",
      "Update_Farming": "કૃષિ સુધારણાઓ",
      "Select_Crop": "ફসল પસંદ કરો",
      "Soyabean": "સોયાબીન",
      "Ground_Nut": "ભૂજંટી",
      "Total_acres_this_Season": "આ સીઝન માટે કુલ એકર",
      "Total_acres": "કુલ એકર",
      "Update": "સુધારો",
      "Farming_details_update": "કૃષિ વિગતો સફળતાપૂર્વક સુધારાઈ છે.",
      "step_2_click": "કદમ 2 માટે OK ક્લિક કરો.",
      "Ok": "ઠીક છે",
      "Click_ok": "કૃષિ વિગતો સફળતાપૂર્વક સુધારાઈ છે. અરોહીતા અને ઇનામો તપાસવા માટે OK ક્લિક કરો.",
      "Congratulations": "આબિનંદન !!!",
      "claim_gifts": "તમે બધા સેટ છો! હવે, તમારા ઇનામોને ક્લેઇમ કરો",
      language: "gujarati",
      "total_acresErrorMsg": "કૃપા કરીને એકર દાખલ કરો",
      visit: "મુલાકાત",
      Name: "નામ",
      thanks_text: "Corteva Reward (Strongarm) કાર્યક્રમમાં ભાગ લેવા બદલ આપનો આભાર!",
      eligible_text: "રમણિય ભેટો માટે પાત્ર બનવા, કૃપા કરીને બધા ફરજિયાત પગલાં પૂર્ણ કરો.",
      Strongarm_Survey: "સ્ટ્રોંગર્મ સર્વે",
      Enter_Details: "વિગતો દાખલ કરો",
      "SelectSteps": "ચરણ પસંદ કરો",
      "termsandconiditionsURL": "http://uat.farmerconnect.in:7000/tracer-microsite/gujarati/termsandconditions.php",
      "profileText": "મીડિયા પ્રોફાઈલ સીવા ફાર્મર કન્ેક્ટ એપ્લિકેશનમાં જારી રહી છે. કૃપા કરીને તમારી રજિસ્ટ્રેશન પૂર્ણ કરો",
      "delegate": "ટ્રેસર",
      "cropErrorMsg": "કૃપા કરીને પાક પસંદ કરો​",
      "nameErrorMsg": "કૃપા કરીને તમારું નામ દાખલ કરો",
      "Reclaim": "પાછુ મડે",
      "loginLabel": "મોબાઇલ નંબર",
      "loginPlaceHolder": "મોબાઇલ નંબર દાખલ કરો",
      "mobileErrorMsg": "કૃપા કરીને મોબાઇલ નંબર દાખલ કરો",
      "submitBtn": "સબમિટ કરો",
      "loginBtn": "નોંધણી કરો",
      "otpText": "OTP SMS દ્વારા {mobileNumber} પર મોકલવામાં આવશે",
      "otpError": "ઓટીપી દાખલ કરો અને લૉગઇનના બટન પર ક્લિક કરો​",
      "OTPLabel": "OTP",
      "firstName": "પ્રથમ નામ",
      "firstNameErrorMsg": "કૃપા કરીને પ્રથમ નામ દાખલ કરો",
      "lastName": "છેલ્લું નામ",
      "lastNameErrorMsg": "કૃપા કરીને છેલ્લું નામ દાખલ કરો",
      "pincode": "પીન કોડ",
      "address": "સરનામું",
      "done": "પૂર્ણ",
      "submit": "સબમિટ કરો",
      "scanTitle": "બોટલ પર QR કોડ સ્કેન કરો",
      "scanning": "સ્કેનિંગ",
      "scan": "સ્કેન",
      "rescan": "ફરીથી સ્કેન કરો",
      "scanSteps": "QR કોડ સ્કેન કરવાનાં પગલાં",
      "stepOne": "પગલું 1: પાઉચમાં QR કોડ શોધો",
      "stepTwo": "પગલું 2: સ્કેન કરો અને QR કોડ સબમિટ કરો",
      "spinToWin": "કોર્ટેવા 'સ્કેન&વીન' દાખલ કરો",
      "scanProduct": "ઉત્પાદન સ્કેન કરો",
      "SpinWheel": "પુરસ્કારો જીતવા માટે વ્હીલ સ્પિન કરો",
      "congratulations": "અભિનંદન",
      "giftcongratulations": "અભિનંદન. તમે વિજેતા છો",
      "earned": "તમને રૂ. 20.00 પ્રતિનિધિ માટે કમાવ્યા",
      "redeemCash": "રોકડ ચૂકવણી મેળવો",
      "ClaimReward": "અને સ્કેન કરો",
      "updatesOnReward": "તમે પ્રતિનિધિ સાથે વિજેતા છો. ભેટની વિગતો માટે તમારા સ્થાનિક કાર્ટેવાના પ્રતિનિધિનો સંપર્ક કરો",
      "paymentMode": "ચુકવણીની રીત પસંદ કરો",
      "bankDetails": "બેંકની વિગતો",
      "accountHolderName": "ખાતાધારકનું નામ​",
      "accountHolderNameErrorMsg": "એકાઉન્ટ નામ જરૂરી છે",
      "accountNumber": "ખાતા નંબર​",
      "accountNumberErrorMsg": "કૃપા કરીને એકાઉન્ટ નંબર દાખલ કરો",
      "IFSCCode": "IFSC કોડ",
      "IFSCCodeErrorMsg": "કૃપા કરીને IFSC કોડ દાખલ કરો",
      "confirm": "નક્કી કરો",
      "UPIErrorMsg": "UPI જરૂરી છે",
      "transferSuccessText": "તમારી કેશ સફળતાપૂર્વક ટ્રાન્સફર થઈ ગઈ",
      "successSubtitile": "અમે તમને નાણાં મોકલી દીધાં છે",
      "goHome": "હોમ પેજ પર જાઓ​",
      "delegateRewards": "પ્રતિનિધિત્વ પુરસ્કારો",
      "claimList": "ક્લેઇમની યાદી",
      "noClaimsFound": "કોઈ દાવા મળ્યા નથી",
      "noSuccessList": "ત્યાં કોઈ વિજય યાદી નથી",
      "reclaimList": "ફરી દાવો યાદી",
      "noReclaimList": "કોઈપણ રીતે ફરી કોઈ દાવો યાદી",
      "privacyPolicy": "ગોપનીયતા નીતિ",
      "agreeText": "સબમિટ કરીને તમે અમારી સાથે સંમત થાઓ છો",
      "genuityCheck": "ઉત્પાદનની અધિકૃતતાની ચકાસણી",
      "FarmerConnect": "ખેડૂત કનેક્ટ પર જાઓ",
      "UpdateFarmingDetails": "કૃષિ વિગતો અપડેટ કરો",
      "ViewProductInfo": "ઉત્પાદન માહિતી જુઓ અને શેર કરો",
      "genuityProduct": "આ મૂળ કોર્ટેવા ઉત્પાદન છે",
      "resendOtp": "OTP ફરીથી મોકલો",
      "productName": "ઉત્પાદનઃ",
      "serialNO": "અનુક્રમ નંબર",
      "alreadyLoginText": "તમારો નંબર ફાર્મર કનેક્ટ એપમાં પણ લોગ થયેલ છે. લોગ ઇન કરવા માટે ઓકે ટેપ કરો.",
      "notRegisteredText": "તમારો નંબર નોંધાયેલો ન હતો. ટ્રેસર બ્લાસ્ટમાં ભાગ લેવા માટે કૃપા કરીને નોંધણી કરો.",
      "loginConfirm": "લૉગિન પુષ્ટિ",
      "Alert": "ચેતવણી!",
      "no": "ના",
      "yes": "હા",
      "OK": "બરાબર",
      "amount": "રૂપિયા",
      "Date": "તારીખ",
      "claim": "ક્લેઇમ",
      "successList": "સફળતાની યાદી",
      "referenceId": "રેફરન્સ આઇડી",
      "status": "સ્થિતિ",
      "Scanmore": "વધુ સ્કેન કરો​",
      "Rewards": "ઇનામ",
      "reward": "ઇનામ",
      "transfer": "ટ્રાન્સફર",
      "home": "ઘર",
      "TC": "T&C",
      "ProductInfo": "ઉત્પાદન <br>विवरालु",
      "downloadBrochure": "બ્રોશર ડાઉનલોડ કરો<br>",
      "programDetails": "પ્રોગ્રામ વિગતો",
      "delegateParticipate": "પ્રતિનિધિ મિત્રતા - ભાગ લો",
      "termsAndConditions": "નિયમો અને શરતો",
      "award": "ઇનામ",
      "TermsandConditons": "નિયમો અને શરત",
      "and": "અને",
      "BackToHome": "પાછા હોમ પેજ પર જાઓ​",
      "ReferenceId": "સંદર્ભ આઈડી",
      "noData": "કોઈ ડેટા નથી",
      "mblnumberPlaceHolder": "રિટેલર મોબાઇલ નંબર",
      "name": "નામ દાખલ કરો",
      "cottn": "કપાસ",
      "corn": "મકાઈ",
      "enterOTP": "OTP નાખો",
      "login": "પ્રવેશ કરો",
      "scanagain": "ફરીથી સ્કેન કરો",
      "Skip": "Skip",
      "Claim": "ક્લેઇમ",
      "StepsImage": "એન્ગેજ ડબલ ધમાકા - આ રીત ભાગ લો",
      "sessionExperied": "સત્ર સમાપ્ત થયું છે. કૃપા કરીને QR કોડ સ્કેન કરો.",
      "confirmaccountNumber": "એકાઉન્ટ નંબરની પુષ્ટિ કરો",
      "confirmaccountNumberErrorMsg": "કૃપા કરીને કન્ફર્મ એકાઉન્ટ નંબર દાખલ કરો",
      "confirmAccountNumberMismatch": 'એકાઉન્ટ નંબર કન્ફર્મેશન મેળ ખાતું નથી',
      "cortevaInfo": "તમારું નામ 'Corteva Farmer Connect' એપમાં નોંધવામાં આવી રહ્યું છે. માહિતી ભરીને તમે કોર્ટેવાને ખેતી અને ઉત્પાદનો સંબંધિત માહિતી માટે સમયાંતરે તમારો સંપર્ક કરવાની મંજૂરી આપો છો.",
      selectPayment: {
        cashbackAmountLabel: "કેશબેક રકમ",
        proceedButton: "આગળ વધો",
        bankDetails: "બેંક ખાતું",
        upi: "યુપીઆઈ",
      },
      scanProductPage: {
        whatsappHelp: "મદદ જોઈએ છે? WhatsApp પર સંપર્ક કરો",
      },
      "knowmore": "વધુ જાણો",
      "consentDetailsTitle": "सहमति विवरण",
      "consentDetails": "आपका नाम 'Corteva Farmer Connect' ऐप में पंजीकृत किया जा रहा है।\n\nआप जो व्यक्तिगत जानकारी (नाम, मोबाइल नंबर, फसल विवरण आदि) प्रदान करते हैं, वह Strongarm™ प्रोग्राम और संबंधित सेवाओं के लिए उपयोग की जाएगी।\n\nआप कोर्टेवा एग्रीसाइंस को यह अनुमति देते हैं कि वे समय-समय पर खेती, उत्पादों, ऑफ़र और प्रोग्राम से जुड़ी जानकारी के लिए आपसे कॉल, SMS या WhatsApp के माध्यम से संपर्क कर सकते हैं।\n\nआपकी जानकारी कोर्टेवा की गोपनीयता नीति के अनुसार सुरक्षित रखी जाएगी। आप कभी भी संपर्क करके अपनी सहमति वापस ले सकते हैं।\n\n'सबमिट' बटन पर क्लिक करके, आप उपरोक्त शर्तों से सहमत होते हैं।",
      "ChangeLanguage": "ભાષા બદલો",
      "consentAgree": "સંમત છું",
      "consentDecline": "નકારું છું",
      "ShareNow": "હમણાં જ શેર કરો",
      "gallant_usedErrorMsg": "Please select whether Gallant was used.",
      "will_buy_strongarm_this_seasonErrorMsg": "Please select when Strongarm will be purchased.",
      "bottleScan": "बोतल स्कैन किए",
      "big_prize_opportunity_title": "बड़े इनाम जीतने का मौका",
      "big_prize_opportunity_desc": "ज़्यादा स्कैन, बड़े इनाम",
      "scan_more": "और स्कैन करें",
      "scan_more_win_bigger_gifts_title": "और स्कैन करें, बड़े उपहार जीतें!",
      "scan_more_win_bigger_gifts_desc": "हर अतिरिक्त स्कैन आपको शानदार पुरस्कारों के करीब लाता है।",
      "next_gift_label": "अगले उपहार के लिए",
      "scan_more_packets_label": "और बोतल स्कैन करें।",
      "reward_history": "Reward History",
      "scanned_products": "स्कैन किए गए उत्पाद",
      "scan_date": "स्कैन की तारीख",
      "packet_id": "बोतल आईडी",
      "gift_history": "उपहारों का इतिहास",
      "reward_win_date": "पुरस्कार जीतने की तारीख",
      "reward": "पुरस्कार",
      "status": "स्थिति",
      "share": "शेयर करें",
      "have_they_used_gallant": "Have they used Gallant in the past?"
    },
  },
  ta: {
    "translation": {
      invalid_OTP: "Invalid OTP ",
      shareText: "I have received a winning Lucky Draw code. Please purchase Strongarm and you can also stand a chance to win.",
      Share: "Share",
      confirmation: "Confirmation",
      All_products_Scanned: "All products Scanned ?",
      No: "No",
      Yes: "Yes",
      resend_OTP: "Resend OTP",
      Next: "Next",
      Mega_Draw_Code: "Mega Draw Code",
      Reward_Won: "Reward Won",
      all_set: "You're all set!",
      go_step2: "Go to Step 2",
      Spin_Wheel_Win: "Spin the Wheel & Win!",
      Spin_Wheel: "Spin Wheel",
      "Continue": "தொடரவும்",
      Eligible_to_win: "You are now Eligible to win",
      Spin_Now: "Spin Now",
      Spin_Win: "Spin and Win",
      Product_Serial_Number: "Product Serial Number",
      "Done": "முடிந்தது",
      "Step_1": "படி 1",
      "Step_2": "படி 2",
      "Update_Farming": "விவசாயத்தை புதுப்பிக்கவும்",
      "Select_Crop": "பண்ணைத் தேர்வு செய்க",
      "Soyabean": "சோயாபீன்",
      "Ground_Nut": "காடலை பருப்பு",
      "Total_acres_this_Season": "இந்த பருவத்திற்கு மொத்த ஏக்கர்",
      "Total_acres": "மொத்த ஏக்கர்",
      "Update": "புதுப்பிக்கவும்",
      "Farming_details_update": "விவசாய விவரங்கள் வெற்றிகரமாக புதுப்பிக்கப்பட்டது.",
      "step_2_click": "படி 2 க்காக OK கிளிக் செய்யவும்.",
      "Ok": "சரி",
      "Click_ok": "விவசாய விவரங்கள் வெற்றிகரமாக புதுப்பிக்கப்பட்டது. இலக்சிபிலிட்டி மற்றும் பரிசுகளை பார்க்க OK கிளிக் செய்யவும்.",
      "Congratulations": "வாழ்த்துக்கள் !!!",
      "claim_gifts": "நீங்கள் அனைத்து செயற்பாடுகளையும் முடித்துவிட்டீர்கள்! இப்போது உங்கள் பரிசுகளை பெறவும்",
      language: "tamil",
      total_acresErrorMsg: "கிராமங்களை உள்ளிடவும்",
      visit: "Visit",
      Name: "Name",
      Strongarm_Survey: "Strongarm Survey",
      "profileText": "உங்கள் சுயவிவரம் Corteva Farmer Connect பயன்பாட்டில் உருவாக்கப்படுகிறது. தயவுசெய்து உங்கள் பதிவை முடிக்கவும்",
      "termsandconiditionsURL": "http://uat.farmerconnect.in:7000/tracer-microsite/tamil/termsandconditions.php",
      "delegate": "ட்ரேசர்",
      "loginLabel": "மொபைல் எண்",
      "loginPlaceHolder": "மொபைல் எண்.",
      "mobileErrorMsg": "மொபைல் எண்ணை உள்ளிடவும்",
      "submitBtn": "சமர்ப்பிக்கவும்",
      "loginBtn": "உள்நுழைக",
      "otpText": "OTP will be sent as an SMS to {mobileNumber}",
      "otpError": "சரியான OTP ஐ உள்ளிடவும்",
      "OTPLabel": "OTP",
      "firstName": "முதல் பெயர்",
      "firstNameErrorMsg": "முதல் பெயரை உள்ளிடவும்",
      "lastName": "கடைசி பெயர்",
      "lastNameErrorMsg": "கடைசி பெயரை உள்ளிடவும்",
      "pincode": "பின்கோடு",
      "address": "முகவரி",
      "done": "முடிந்தது",
      "submit": "சமர்ப்பிக்கவும்",
      "scanTitle": "பாட்டிலில் QR குறியீட்டை ஸ்கேன் செய்யவும் ",
      "scanning": "ஸ்கேன் செய்கிறது",
      "scan": "ஸ்கேன் செய்யவும் ",
      "rescan": "மேலும் ஸ்கேன் செய்யவும்",
      "scanSteps": "Steps to scan the QR code",
      "stepOne": "Step 1: Find the QR code on the pouch",
      "stepTwo": "Step 2: Scan the QR code and submit",
      "spinToWin": "விருதுகளைப் பெறுங்கள்",
      "scanProduct": "Scan Product",
      "SpinWheel": "வெகுமதியைப் பெற சக்கரத்தை சுழற்றுங்கள்",
      "congratulations": "வாழ்த்துக்கள்",
      "giftcongratulations": "வாழ்த்துக்கள், நீங்கள் ஒரு வெற்றியாளர்!",
      "earned": "You have earned Rs. 20.00 cash for Delegate",
      "redeemCash": "பணத்தை மீட்டுக்கொள்ளுங்கள் ",
      "ClaimReward": "வெகுமதியைக் கோருங்கள்",
      "updatesOnReward": "நீங்கள் டிரேசர் யுடன் வெற்றி பெற்றவர். வெகுமதி பற்றிய அறிவிப்புகளுக்கு உங்கள் உள்ளூர் Corteva டிரேசர்யைத் தொடர்புகொள்ளவும்",
      "paymentMode": "பணப்பரிமாற்றம் முறையைத் தேர்ந்தெடுக்கவும். ",
      "accountHolderName": "வங்கி கணக்கு பெயர்",
      "accountHolderNameErrorMsg": "கணக்கு வைத்திருப்பவரின் பெயர் தேவை",
      "accountNumber": "வங்கி கணக்கு எண்",
      "accountNumberErrorMsg": "கணக்கு எண்ணை உள்ளிடவும்",
      "IFSCCode": "IFSC குறியீடு.",
      "IFSCCodeErrorMsg": "IFSC குறியீட்டை உள்ளிடவும்",
      "confirm": "உறுதிப்படுத்தவும்.",
      "UPIErrorMsg": "UPI ஐ உள்ளிடவும்.",
      "transferSuccessText": "உங்கள் பணப் பரிமாற்றம் வெற்றிகரமாக உள்ளது. ",
      "successSubtitile": "உங்கள் பணத்தை அனுப்பியுள்ளோம்!",
      "goHome": "முகப்புப் பக்கத்திற்குத் திரும்பு ",
      "delegateRewards": "டெலிகேட் பரிசுகள்",
      "claimList": " உரிமைகோரல் பட்டியல்",
      "noClaimsFound": "உரிமைகோரல்கள் எதுவும் இல்லை",
      "noSuccessList": "வெற்றிப் பட்டியல் எதுவும் இல்லை",
      "reclaimList": "மீட்டெடுப்பு பட்டியல்",
      "noReclaimList": "மீட்டெடுப்பு பட்டியல் எதுவும் இல்லை",
      "privacyPolicy": "தனியுரிமைக் கொள்கை",
      "agreeText": "சமர்ப்பிப்பதன் மூலம், எங்கள் விதிமுறைகளை ஏற்கிறீர்கள்",
      "genuityCheck": "தயாரிப்பின் உண்மைத்தன்மை சரிபார்ப்பு",
      "resendOtp": "OTP ஐ மீண்டும் அனுப்பவும்",
      "productName": "தயாரிப்பு",
      "serialNO": "வரிசை எண்",
      "alreadyLoginText": "Your number is also logged in to the Farmer Connect app. Press OK to log in.",
      "notRegisteredText": "Your number is not registered. Please register to participate in Delegate Blast.",
      "loginConfirm": "Login Confirmation",
      "Alert": "Alert!",
      "no": "No",
      "yes": "Yes",
      "OK": "OK",
      "amount": "தொகை",
      "Date": "தேதி",
      "claim": "உரிமைகோரவும்",
      "successList": "வெற்றி பட்டியல்",
      "referenceId": "குறிப்பு ஐடி",
      "status": "நிலை",
      "Scanmore": "மேலும் ஸ்கேன் செய்யவும்",
      "Rewards": "பரிசுகள்",
      "reward": "பரிசுகள்",
      "transfer": "பணப்பரிமாற்றம் ",
      "home": "வீடு",
      "TC": "T&C",
      "ProductInfo": "தயாரிப்பு தகவல்",
      "downloadBrochure": "சிற்றேட்டைப் பதிவிறக்கவும் <br> ",
      "programDetails": "நிரல் விவரங்கள்",
      "delegateParticipate": "Delegate Friendship Blast - Participate",
      "termsAndConditions": "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      "award": "விருது",
      "TermsandConditons": "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      "and": "and",
      "BackToHome": "முகப்புப் பக்கத்திற்குத் திரும்பு ",
      "ReferenceId": "குறிப்பு ஐடி",
      "noData": "தரவு எதுவும் கிடைக்கவில்லை",
      "mblnumberPlaceHolder": "சில்லறை விற்பனையாளரின் மொபைல் எண்",
      "name": "பெயர்",
      "cottn": "பருத்தி",
      "corn": "சோளம்",
      "enterOTP": "OTP ஐ உள்ளிடவும்",
      "login": "உள்நுழைக",
      "scanagain": "மேலும் ஸ்கேன் செய்யவும்",
      "cropErrorMsg": "தயவு செய்து பயிர் ஒன்றைத் தேர்ந்தெடுக்கவும்",
      "nameErrorMsg": "தயவுசெய்து உங்கள் பெயரை உள்ளிடவும்",
      "Reclaim": "மீட்டெடுக்கவும்",
      "Skip": "Skip",
      "Claim": "உரிமைகோரவும்",
      "StepsImage": "டிரேசர்த்துவ இரட்டை தமாகா - எப்படி பங்கேற்பது",
      "UPI": "UPI",
      "bankDetails": "வங்கி விவரங்கள்",
      "confirmaccountNumber": "கணக்கு எண்ணை உறுதிப்படுத்தவும்",
      "confirmaccountNumberErrorMsg": "உறுதிப்படுத்தல் கணக்கு எண்ணை உள்ளிடவும்",
      "confirmAccountNumberMismatch": 'கணக்கு எண் உறுதிப்படுத்தல் பொருந்தவில்லை',
      "sessionExperied": "அமர்வு முடிந்துவிட்டது. தயவுசெய்து QR குறியீட்டை ஸ்கேன் செய்யவும்.",
      "cortevaInfo": "உங்கள் பெயர் 'Corteva Farmer Connect' செயலியில் பதிவு செய்யப்படுகிறது. இந்தத் தகவலை வழங்குவதன் மூலம், விவசாயம் மற்றும் தயாரிப்புகள் தொடர்பான தகவல்களை வழங்க கோர்டேவா அவ்வப்போது உங்களைத் தொடர்புகொள்ள அனுமதி அளிக்கிறீர்கள்.",
      selectPayment: {
        cashbackAmountLabel: "கேஷ்பேக் தொகை",
        proceedButton: "தொடரவும்",
        bankDetails: "வங்கி கணக்கு",
        upi: "யூபிஐ",
      },
      scanProductPage: {
        whatsappHelp: "உதவி வேண்டுமா? WhatsApp இல் தொடர்பு கொள்ளுங்கள்",
      },
      "knowmore": "மேலும் அறிய",
      "consentDetailsTitle": "सहमति विवरण",
      "consentDetails": "आपका नाम 'Corteva Farmer Connect' ऐप में पंजीकृत किया जा रहा है।\n\nआप जो व्यक्तिगत जानकारी (नाम, मोबाइल नंबर, फसल विवरण आदि) प्रदान करते हैं, वह Strongarm™ प्रोग्राम और संबंधित सेवाओं के लिए उपयोग की जाएगी।\n\nआप कोर्टेवा एग्रीसाइंस को यह अनुमति देते हैं कि वे समय-समय पर खेती, उत्पादों, ऑफ़र और प्रोग्राम से जुड़ी जानकारी के लिए आपसे कॉल, SMS या WhatsApp के माध्यम से संपर्क कर सकते हैं।\n\nआपकी जानकारी कोर्टेवा की गोपनीयता नीति के अनुसार सुरक्षित रखी जाएगी। आप कभी भी संपर्क करके अपनी सहमति वापस ले सकते हैं।\n\n'सबमिट' बटन पर क्लिक करके, आप उपरोक्त शर्तों से सहमत होते हैं।",
      "ChangeLanguage": "மொழியை மாற்றவும்",
      "consentAgree": "ஏற்கிறேன்",
      "consentDecline": "நிராகரிக்கிறேன்",
      "ShareNow": "இப்போதே பகிரவும்",
      "gallant_usedErrorMsg": "Please select whether Gallant was used.",
      "will_buy_strongarm_this_seasonErrorMsg": "Please select when Strongarm will be purchased.",
      "bottleScan": "बोतल स्कैन किए",
      "big_prize_opportunity_title": "बड़े इनाम जीतने का मौका",
      "big_prize_opportunity_desc": "ज़्यादा स्कैन, बड़े इनाम",
      "scan_more": "और स्कैन करें",
      "scan_more_win_bigger_gifts_title": "और स्कैन करें, बड़े उपहार जीतें!",
      "scan_more_win_bigger_gifts_desc": "हर अतिरिक्त स्कैन आपको शानदार पुरस्कारों के करीब लाता है।",
      "next_gift_label": "अगले उपहार के लिए",
      "scan_more_packets_label": "और बोतल स्कैन करें।",
      "reward_history": "Reward History",
      "scanned_products": "स्कैन किए गए उत्पाद",
      "scan_date": "स्कैन की तारीख",
      "packet_id": "बोतल आईडी",
      "gift_history": "उपहारों का इतिहास",
      "reward_win_date": "पुरस्कार जीतने की तारीख",
      "reward": "पुरस्कार",
      "status": "स्थिति",
      "share": "शेयर करें",
      "have_they_used_gallant": "Have they used Gallant in the past?"
    }
  },
  or: {
    "translation": {
      confirmation: "Confirmation",
      shareText: "I have received a winning Lucky Draw code. Please purchase Strongarm and you can also stand a chance to win.",
      Share: "Share",
      All_products_Scanned: "All products Scanned ?",
      No: "No",
      Yes: "Yes",
      invalid_OTP: "Invalid OTP ",
      resend_OTP: "Resend OTP",
      Next: "Next",
      Mega_Draw_Code: "Mega Draw Code",
      Reward_Won: "Reward Won",
      all_set: "You're all set!",
      go_step2: "Go to Step 2",
      Spin_Wheel_Win: "Spin the Wheel & Win!",
      Spin_Wheel: "Spin Wheel",
      "Continue": "ଚଲାନ୍ତୁ",
      Eligible_to_win: "You are now Eligible to win",
      Spin_Now: "Spin Now",
      Spin_Win: "Spin and Win",
      Product_Serial_Number: "Product Serial Number",
      "Done": "ସମ୍ପୂର୍ଣ୍ଣ",
      "Step_1": "ଚରଣ 1",
      "Step_2": "ଚରଣ 2",
      "Update_Farming": "କୃଷି ଅପଡେଟ୍ କରନ୍ତୁ",
      "Select_Crop": "ଫସଲ ଚୟନ କରନ୍ତୁ",
      "Soyabean": "ସୋୟାବିନ",
      "Ground_Nut": "ଭୂତା ମିସ୍ରଣ",
      "Total_acres_this_Season": "ଏହି ଋତୁରେ ମୋଟ ଏକର",
      "Total_acres": "ମୋଟ ଏକର",
      "Update": "ଅପଡେଟ୍",
      "Farming_details_update": "କୃଷି ବିବରଣୀ ସଫଳତାର ସହିତ ଅପଡେଟ୍ ହେଲା।",
      "step_2_click": "ଚରଣ 2 ପାଇଁ OK କ୍ଲିକ୍ କରନ୍ତୁ।",
      "Ok": "ଠିକ୍",
      "Click_ok": "କୃଷି ବିବରଣୀ ସଫଳତାର ସହିତ ଅପଡେଟ୍ ହେଲା। ଇଲିଜିବିଲିଟି ଏବଂ ପୁରସ୍କାର ପ୍ରଦାନ ପାଇଁ OK କ୍ଲିକ୍ କରନ୍ତୁ।",
      "Congratulations": "ବଧାଇ !!",
      "claim_gifts": "ଆପଣ ସମସ୍ତ ଚରଣ ଶେଷ କରିଛନ୍ତି! ଏବେ, ଆପଣଙ୍କର ପୁରସ୍କାର ଦାବି କରନ୍ତୁ",
      language: "odiya",
      total_acresErrorMsg: "ଦୟାକରି ଏକର ଦାଖଲ କରନ୍ତୁ",
      visit: "Visit",
      Name: "Name",
      Strongarm_Survey: "Strongarm Survey",
      "profileText": "ତୁମର ପ୍ରୋଫାଇଲ୍ କର୍ଟେଭା ଫାର୍ମର୍ କନେକ୍ଟ ଆପରେ ସୃଷ୍ଟି ହେଉଛି | ଦୟାକରି ଆପଣଙ୍କର ପଞ୍ଜୀକରଣ ସମ୍ପୂର୍ଣ୍ଣ କରନ୍ତୁ |",
      "termsandconiditionsURL": "http://uat.farmerconnect.in:7000/tracer-microsite/hindi/termsandconditions.php",
      "delegate": "ଟ୍ରେସର",
      "loginLabel": "ମୋବାଇଲ୍ ନମ୍ବର |",
      "loginPlaceHolder": "ମୋବାଇଲ୍ ନଂ।",
      "mobileErrorMsg": "ଦୟାକରି ମୋବାଇଲ୍ ନମ୍ବର ପ୍ରବେଶ କରନ୍ତୁ |",
      submitBtn: "ନିବେଦନ କରିବା ",
      loginBtn: "ଲଗିଂ",
      otpText: "ओटीपी {mobileNumber} पर एसएमएस के रूप में भेजा जाएगा",
      otpError: "ଦୟାକରି ସଠିକ OTP ପ୍ରବେଶ କରନ୍ତୁ ",
      OTPLabel: "ओटीपी",
      firstName: "पहला नाम",
      firstNameErrorMsg: "कृपया प्रथम नाम दर्ज करें",
      lastName: "अंतिम नाम",
      lastNameErrorMsg: "कृपया अंतिम नाम दर्ज करें",
      pincode: "पिन कोड",
      address: "पता",
      done: "हो गया",
      submit: "ଦାଖଲ କର |",
      scanTitle: "ବୋତଲ ଉପରେ ଥିବା  QR କୋଡ ସ୍କାନ କରନ୍ତୁ",
      scanning: "स्कैनिंग",
      scan: "ସ୍କାନ",
      rescan: "ପୁନର୍ବାର ସ୍କାନ୍ କରନ୍ତୁ |",
      scanSteps: "क्यूआर कोड को स्कैन करने के चरण",
      stepOne: "चरण 1: पाउच पर क्यूआर कोड खोजें",
      stepTwo: "चरण 2: क्यूआर कोड को स्कैन करें और सबमिट करें",
      "spinToWin": "ପୁରସ୍କାର ଦାବି କରନ୍ତୁ",
      scanProduct: "ଉତ୍ପାଦ ସ୍କାନ୍ କରନ୍ତୁ |",
      SpinWheel: "ଘୁରାନ୍ତୁ ଆଉ ପୁରସ୍କାର ଜିତନ୍ତୁ ",
      congratulations: "ଅଭିନନ୍ଦନ",
      giftcongratulations: "ଅଭିନନ୍ଦନ, ଆପଣ ବିଜେତା |​",
      earned: "आपने रु. कमाए हैं. पेक्सालोन के लिए 20.00 नकद",
      redeemCash: "ମୋଚନ କରନ୍ତୁ",
      ClaimReward: "ପୁରସ୍କାର ଦାବି କରନ୍ତୁ |",
      "updatesOnReward": "ଆପଣ ଟ୍ରେସର ସହ ଜିତୁଛନ୍ତି। ପୁରସ୍କାର ଆଦାନ-ପ୍ରଦାନ ସମ୍ବନ୍ଧୀୟ ଅଧିକାରୀ ସୂଚନା ପାଇଁ ଆପଣଙ୍କ ସ୍ଥାନୀୟ କୋର୍ଟେଭା ପ୍ରତିନିଧି ସହ ସମ୍ପର୍କ କରନ୍ତୁ",
      paymentMode: "ଚୟନ ଅର୍ଥ ପ୍ରଦାନ​",
      accountHolderName: "ହିସାବ ନାମ​",
      accountHolderNameErrorMsg: "ଖାତା ନାମ ଆବଶ୍ୟକ |",
      accountNumber: "ହିସାବ ନମ୍ବର ",
      accountNumberErrorMsg: "ଦୟାକରି ଖାତା ନମ୍ବର ପ୍ରବେଶ କରନ୍ତୁ |",
      IFSCCode: "IFSC କୋଡ",
      IFSCCodeErrorMsg: "ଦୟାକରି IFSC କୋଡ୍ ପ୍ରବେଶ କରନ୍ତୁ |",
      confirm: "ସମର୍ଥନ",
      UPIErrorMsg: "UPI ଆବଶ୍ୟକ |",
      transferSuccessText: "ଆପଣଙ୍କ ଟଙ୍କା ବଦଳି କରିବା ସଫଳ ​",
      successSubtitile: "ଆମେ ତୁମ ଟଙ୍କା ପଠାଇଛୁ!",
      goHome: "ହୋମ ପେଜ କୁ ",
      "delegateRewards": "ଟ୍ରେସର ପୁରସ୍କାର",
      claimList: "ଦାବି କରନ୍ତୁ ତାଲିକା",
      noClaimsFound: "କ claims ଣସି ଦାବି ମିଳିଲା ନାହିଁ |",
      noSuccessList: "କ success ଣସି ସଫଳତା ତାଲିକା ମିଳିଲା ନାହିଁ |",
      reclaimList: "ପୁନରୁଦ୍ଧାର ତାଲିକା |",
      noReclaimList: "କ rec ଣସି ପୁନରୁଦ୍ଧାର ତାଲିକା ମିଳିଲା ନାହିଁ |",
      agreeText: "ଦାଖଲ କରି ତୁମେ ଆମର ସହମତ |",
      "genuityCheck": "ଉତ୍ପାଦନର ପ୍ରମାଣିକତା ପରୀକ୍ଷା",
      resendOtp: "OTP पुन: भेजें",
      productName: "ପେକ୍ସIଲନ",
      serialNO: "ସେରିଏଲ ନମ୍ବର",
      alreadyLoginText: "ଆପଣଙ୍କର ନମ୍ବର ମଧ୍ୟ ଫାର୍ମ କନେକ୍ଟ ଆପରେ ଲଗ୍ ହୋଇଛି | ଲଗ୍ ଇନ୍ କରିବାକୁ ଓକେ ଦବାନ୍ତୁ |​",
      "notRegisteredText": "ଆପଣଙ୍କର ନମ୍ବର ରେଜିଷ୍ଟର ହୋଇନି। ଟ୍ରେସର ବ୍ଲାସ୍ଟରେ ଭାଗ ନେବା ପାଇଁ ଦୟାକରି ରେଜିଷ୍ଟର କରନ୍ତୁ।",
      loginConfirm: "ଲଗଇନ୍ ନିଶ୍ଚିତକରଣ |",
      Alert: "ଚେତାବନୀ!",
      no: "ନା",
      yes: "ହଁ",
      OK: "ଠିକ ଅଛି |",
      amount: "Rs, ୦୦୦ ଟଙ୍କା",
      Date: "ତାରିଖ",
      claim: "ଦାବି",
      successList: "ସଫଳତା ତାଲିକା",
      referenceId: "ପ୍ରସଙ୍ଗ ID",
      status: "ଅବସ୍ଥା",
      Scanmore: "ଅଧିକ ସ୍କାନ୍ କରନ୍ତୁ |​",
      Rewards: "ପୁରସ୍କାର",
      reward: "ପୁରସ୍କାର",
      transfer: "ବଦଳି କରିବା",
      home: "ଘର",
      TC: "T&C",
      ProductInfo: "ଉତ୍ପାଦ ସୂଚନା",
      downloadBrochure: "ବ୍ରୋସର ଡାଉନଲୋଡ୍ କରନ୍ତୁ |",
      programDetails: "ପ୍ରୋଗ୍ରାମ ବର୍ଣ୍ଣନା",
      "delegateParticipate": "ଟ୍ରେସର ଫ୍ରେଣ୍ଡଶିପ୍ ବ୍ଲାସ୍ଟ - ଭାଗ ନେବେ",
      "termsAndConditions": "ଶର୍ତ୍ତ ଓ ନିୟମ",
      award: "ପୁରସ୍କାର",
      TermsandConditons: "ସର୍ତ୍ତାବଳୀ",
      and: "ଏବଂ",
      privacyPolicy: "ଗୋପନୀୟତା ନୀତି",
      BackToHome: "ହୋମ ପେଜ କୁ ଫେରନ୍ତୁ ",
      ReferenceId: "ପ୍ରସଙ୍ଗ ID",
      noData: "କ data ଣସି ତଥ୍ୟ ଉପଲବ୍ଧ ନାହିଁ |",
      mblnumberPlaceHolder: 'ଖୁଚୁରା ବ୍ୟବସାୟୀଙ୍କ ମୋବାଇଲ୍ ନମ୍ବର |',
      name: "ନାମ",
      cottn: "କପା",
      corn: "ମକା",
      enterOTP: "ପ୍ରବେଶ OTP",
      login: "ଲଗଇନ୍​",
      scanagain: "ପୁନର୍ବାର ସ୍କାନ୍ କରନ୍ତୁ |",
      cropErrorMsg: "ଦୟାକରି ଫସଲ ଚୟନ କରନ୍ତୁ |",
      nameErrorMsg: "ଦୟାକରି ଆପଣଙ୍କର ନାମ ପ୍ରବେଶ କରନ୍ତୁ |",
      Reclaim: "ଦାବି ତାଲିକା",
      Skip: "Skip",
      Claim: "ଦାବି",
      "StepsImage": "ଟ୍ରେସର ଡବଲ୍ ବ୍ଲାସ୍ଟ - କିପରି ଭାଗ ନେବେ",
      UPI: "UPI",
      bankDetails: "ବ୍ୟାଙ୍କ ବିବରଣୀ",
      "confirmaccountNumber": "ସମର୍ଥନ ହିସାବ ନମ୍ବର ",
      "confirmaccountNumberErrorMsg": "ନିଶ୍ଚିତ କରିବାକୁ ଖାତା ନମ୍ବର ପ୍ରବେଶ କରନ୍ତୁ |",
      "confirmAccountNumberMismatch": 'ଆକାଉଣ୍ଟ ନମ୍ବର ମେଳ ହେବା ଦରକାର ',
      "sessionExperied": "କେନ୍ଦ୍ର ସମାପ୍ତ ହୋଇଛି। ଦୟାକରି QR କୋଡ୍ ସ୍କାନ୍ କରନ୍ତୁ।",
      "cortevaInfo": "ଆପଣଙ୍କ ନାମ 'Corteva Farmer Connect' ଆପ୍‌ରେ ପଞ୍ଜିକୃତ କରାଯାଉଛି। ସୂଚନା ପୂରଣ କରି ଆପଣ କୋର୍ଟେଭାକୁ କୃଷି ଏବଂ ଉତ୍ପାଦ ସମ୍ବନ୍ଧୀୟ ସୂଚନା ପାଇଁ ସମୟ ସମୟରେ ଆପଣଙ୍କ ସହିତ ଯୋଗାଯୋଗ କରିବାର ଅନୁମତି ଦେଉଛନ୍ତି।",
      selectPayment: {
        cashbackAmountLabel: "କ୍ୟାସବ୍ୟାକ ପରିମାଣ",
        proceedButton: "ଆଗକୁ ବଢ଼ନ୍ତୁ",
        bankDetails: "ବ୍ୟାଙ୍କ ଖାତା",
        upi: "ୟୁପିଆଇ",
      },
      scanProductPage: {
        whatsappHelp: "ସାହାଯ୍ୟ ଦରକାର? WhatsApp ରେ ଯୋଗାଯୋଗ କରନ୍ତୁ",
      },
      "knowmore": "ଅଧିକ ଜାଣନ୍ତୁ",
      "consentDetailsTitle": "सहमति विवरण",
      "consentDetails": "आपका नाम 'Corteva Farmer Connect' ऐप में पंजीकृत किया जा रहा है।\n\nआप जो व्यक्तिगत जानकारी (नाम, मोबाइल नंबर, फसल विवरण आदि) प्रदान करते हैं, वह Strongarm™ प्रोग्राम और संबंधित सेवाओं के लिए उपयोग की जाएगी।\n\nआप कोर्टेवा एग्रीसाइंस को यह अनुमति देते हैं कि वे समय-समय पर खेती, उत्पादों, ऑफ़र और प्रोग्राम से जुड़ी जानकारी के लिए आपसे कॉल, SMS या WhatsApp के माध्यम से संपर्क कर सकते हैं।\n\nआपकी जानकारी कोर्टेवा की गोपनीयता नीति के अनुसार सुरक्षित रखी जाएगी। आप कभी भी संपर्क करके अपनी सहमति वापस ले सकते हैं।\n\n'सबमिट' बटन पर क्लिक करके, आप उपरोक्त शर्तों से सहमत होते हैं।",
      "ChangeLanguage": "ଭାଷା ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
      "consentAgree": "ସମ୍ମତ",
      "consentDecline": "ପ୍ରତ୍ୟାଖ୍ୟାନ କରନ୍ତୁ",
      "ShareNow": "ଏବେ ହିଁ ସେୟାର କରନ୍ତୁ",
      "gallant_usedErrorMsg": "Please select whether Gallant was used.",
      "will_buy_strongarm_this_seasonErrorMsg": "Please select when Strongarm will be purchased.",
      "bottleScan": "बोतल स्कैन किए",
      "big_prize_opportunity_title": "बड़े इनाम जीतने का मौका",
      "big_prize_opportunity_desc": "ज़्यादा स्कैन, बड़े इनाम"
    }
  },
  bn: {
    "translation": {
      confirmation: "Confirmation",
      shareText: "I have received a winning Lucky Draw code. Please purchase Strongarm and you can also stand a chance to win.",
      Share: "Share",
      All_products_Scanned: "All products Scanned ?",
      No: "No",
      Yes: "Yes",
      invalid_OTP: "Invalid OTP ",
      resend_OTP: "Resend OTP",
      Next: "Next",
      Mega_Draw_Code: "Mega Draw Code",
      Reward_Won: "Reward Won",
      all_set: "You're all set!",
      go_step2: "Go to Step 2",
      Spin_Wheel_Win: "Spin the Wheel & Win!",
      Spin_Wheel: "Spin Wheel",
      "Continue": "চলুন",
      Eligible_to_win: "You are now Eligible to win",
      Spin_Now: "Spin Now",
      Spin_Win: "Spin and Win",
      Product_Serial_Number: "Product Serial Number",
      "Done": "সম্পন্ন",
      "Step_1": "ধাপ 1",
      "Step_2": "ধাপ 2",
      "Update_Farming": "কৃষি আপডেট করুন",
      "Select_Crop": "ফসল নির্বাচন করুন",
      "Soyabean": "সয়াবিন",
      "Ground_Nut": "মিন্তি বাদাম",
      "Total_acres_this_Season": "এই মৌসুমে মোট একর",
      "Total_acres": "মোট একর",
      "Update": "আপডেট করুন",
      "Farming_details_update": "কৃষি বিবরণ সফলভাবে আপডেট হয়েছে।",
      "step_2_click": "ধাপ 2 এর জন্য OK ক্লিক করুন।",
      "Ok": "ঠিক আছে",
      "Click_ok": "কৃষি বিবরণ সফলভাবে আপডেট হয়েছে। যোগ্যতা এবং পুরস্কারের জন্য OK ক্লিক করুন।",
      "Congratulations": "অভিনন্দন !!!",
      "claim_gifts": "আপনি সব সেট! এখন, আপনার পুরস্কার দাবি করুন",
      language: "bangla",
      total_acresErrorMsg: "দয়া করে একর প্রবেশ করুন",
      visit: "Visit",
      Name: "Name",
      Strongarm_Survey: "Strongarm Survey",
      "sessionExperied": "কেন্দ্র শেষ হওয়া। দয়া করে QR কোড স্ক্যান করুন",
      "profileText": "কর্টেভা ফার্মার কানেক্ট অ্যাপে আপনার প্রোফাইল তৈরি করা হচ্ছে। আপনার নিবন্ধন সম্পূর্ণ করুন",
      "termsandconiditionsURL": "http://uat.farmerconnect.in:7000/tracer-microsite/hindi/termsandconditions.php",
      "delegate": "ট্রেসার",
      "loginLabel": "মোবাইল নম্বর",
      "loginPlaceHolder": "মোবাইল নম্বর",
      "mobileErrorMsg": "মোবাইল নম্বর লিখুন",
      "submitBtn": "সাবমিট করুন",
      "loginBtn": "লগ ইন",
      "otpText": "ओटीपी {mobileNumber} पर एसएमएस के रूप में भेजा जाएगा",
      "otpError": "অনুগ্রহ করে বৈধ OTP লিখুন",
      OTPLabel: "ओटीपी",
      firstName: "पहला नाम",
      firstNameErrorMsg: "कृपया प्रथम नाम दर्ज करें",
      lastName: "अंतिम नाम",
      lastNameErrorMsg: "कृपया अंतिम नाम दर्ज करें",
      pincode: "पिन कोड",
      address: "पता",
      done: "हो गया",
      submit: "জমা",
      "scanTitle": "ট্বোতলে দেওয়া কিউআর কোড স্ক্যান করুন",
      scanning: "স্ক্যানিং",
      scan: "স্ক্যান",
      rescan: "আবার স্ক্যান করুন",
      scanSteps: "QR কোড স্ক্যান করার ধাপ",
      stepOne: "चरण 1: पाउच पर क्यूआर कोड खोजें",
      stepTwo: "चरण 2: क्यूआर कोड को स्कैन करें और सबमिट करें",
      "spinToWin": "পুরস্কার দাবি করুন",
      scanProduct: "পণ্য স্ক্যান করুন",
      SpinWheel: "পুরস্কার জেতার জন্য হুইলটিকে ঘোরান।",
      congratulations: "অভিনন্দন",
      giftcongratulations: "অভিনন্দন, আপনি বিজয়ী.​",
      "earned": "আপনি ট্রেসার এর জন্য ₹২০.০০ নগদ উপার্জন করেছেন",
      redeemCash: "পান ক্যাশ পেমেন্ট",
      ClaimReward: "আরও স্ক্যান করুন",
      "updatesOnReward": "আপনি ট্রেসার সহ বিজয়ী। পুরস্কারের আপডেটের জন্য আপনার স্থানীয় কোরটেভা প্রতিনিধির সাথে যোগাযোগ করুন",
      paymentMode: "পেমেন্ট মোড সিলেক্ট করুন​",
      accountHolderName: "অ্যাকাউন্ট ধারকের নাম​",
      accountHolderNameErrorMsg: "অ্যাকাউন্টের নাম প্রয়োজন",
      accountNumber: "অ্যাকাউন্ট নম্বর​",
      accountNumberErrorMsg: "অনুগ্রহ করে অ্যাকাউন্ট নম্বর লিখুন",
      IFSCCode: "IFSC কোড",
      IFSCCodeErrorMsg: "অনুগ্রহ করে IFSC কোড লিখুন",
      confirm: "নিশ্চিত করুন",
      UPIErrorMsg: "ইউপিআই প্রয়োজন",
      transferSuccessText: "আপনার ক্যাশ ট্র্যান্সফার সফল হয়েছে​",
      successSubtitile: "আপনি আপনার টাকা পাঠিয়েছেন",
      goHome: "হোম পেজে যান",
      "delegateRewards": "ট্রেসার পুরস্কার",
      claimList: "ক্লেইম লিস্ট",
      noClaimsFound: "কোনো দাবি পাওয়া যায়নি",
      noSuccessList: "কোনো সাফল্যের তালিকা পাওয়া যায়নি",
      reclaimList: "পুনরায় ক্লেম করার লিস্ট",
      noReclaimList: "কোনো পুনরুদ্ধারের তালিকা পাওয়া যায়নি",
      agreeText: "জমা দিয়ে আপনি আমাদের সাথে সম্মত হন",
      "genuityCheck": "পণ্যের সত্যতা যাচাই",
      resendOtp: "OTP আবার পাঠান",
      productName: "প্রোডাক্ট",
      serialNO: "সিরিয়েল নম্বর",
      alreadyLoginText: "আপনার নম্বরটি Farmer Connect অ্যাপে লগ ইন করা আছে। লগ ইন করতে ওকে টিপুন।​",
      "notRegisteredText": "আপনার নম্বর নিবন্ধিত নয়। ট্রেসার ব্লাস্টে অংশগ্রহণ করার জন্য দয়া করে নিবন্ধন করুন।",
      loginConfirm: "লগইন নিশ্চিতকরণ",
      Alert: "সতর্কতা !",
      no: "नहीं",
      yes: "हाँ",
      OK: "स्वीकार करना",
      amount: "रुपये",
      Date: "তারিখ",
      claim: "ক্লেম",
      successList: "সাকসেস লিস্ট",
      referenceId: "রেফারেন্স ID ",
      status: "স্থিতি",
      Scanmore: "আরও স্ক্যান করুন​",
      Rewards: "পুরস্কার",
      reward: "পুরস্কার",
      transfer: "ট্রান্সফার করুন",
      home: "বাড়ি",
      TC: "T&C",
      ProductInfo: "পণ্য তথ্য",
      downloadBrochure: "ব্রোশার ডাউনলোড করুন",
      programDetails: "প্রোগ্রাম বিবরণ",
      "delegateParticipate": "ট্রেসার ফ্রেন্ডশিপ ব্লাস্ট - অংশগ্রহণ করুন",
      "termsAndConditions": "শর্তাবলী",
      award: "পুরস্কার",
      TermsandConditons: "শর্তাবলী",
      and: "এবং",
      privacyPolicy: "গোপনীয়তা নীতি",
      BackToHome: "হোম পেজে ফেরত",
      ReferenceId: "রেফারেন্স ID",
      noData: "কোন তথ্য উপলব্ধ",
      mblnumberPlaceHolder: 'খুচরা বিক্রেতার মোবাইল নম্বর',
      name: "নাম",
      cottn: "তুলা",
      corn: "ভুট্টা",
      enterOTP: "OTP দিন",
      login: "লগ ইন​",
      scanagain: "আবার স্ক্যান করুন",
      cropErrorMsg: "ফসল নির্বাচন করুন​",
      nameErrorMsg: "আপনার নাম লিখুন",
      Reclaim: "পুনরুদ্ধার",
      Skip: "Skip",
      Claim: "ক্লেম",
      "StepsImage": "ট্রেসার ডাবল ব্লাস্ট - কিভাবে অংশগ্রহণ করবেন",
      UPI: "ইউ পি আই",
      bankDetails: "ব্যাংকের বিবরণ",
      "confirmaccountNumber": "অ্যাকাউন্ট নম্বর চেক করুন",
      "confirmaccountNumberErrorMsg": "নিশ্চিত করতে অ্যাকাউন্ট নম্বর লিখুন",
      "confirmAccountNumberMismatch": 'অ্যাকাউন্ট নম্বর মেলে না কিনা পরীক্ষা করুন',
      "cortevaInfo": "আপনার নাম 'Corteva Farmer Connect' অ্যাপে নিবন্ধিত করা হচ্ছে। তথ্য পূরণ করার মাধ্যমে আপনি কর্টেভাকে কৃষি ও পণ্য সম্পর্কিত তথ্যের জন্য সময়ে সময়ে আপনার সাথে যোগাযোগ করার অনুমতি দিচ্ছেন।",
      selectPayment: {
        cashbackAmountLabel: "ক্যাশব্যাক অঙ্ক",
        proceedButton: "এগিয়ে যান",
        bankDetails: "ব্যাংক অ্যাকাউন্ট",
        upi: "ইউপিআই",
      },
      scanProductPage: {
        whatsappHelp: "সাহায্য দরকার? WhatsApp এ যোগাযোগ করুন",
      },
      "knowmore": "আরও জানুন",
      "consentDetailsTitle": "सहमति विवरण",
      "consentDetails": "आपका नाम 'Corteva Farmer Connect' ऐप में पंजीकृत किया जा रहा है।\n\nआप जो व्यक्तिगत जानकारी (नाम, मोबाइल नंबर, फसल विवरण आदि) प्रदान करते हैं, वह Strongarm™ प्रोग्राम और संबंधित सेवाओं के लिए उपयोग की जाएगी।\n\nआप कोर्टेवा एग्रीसाइंस को यह अनुमति देते हैं कि वे समय-समय पर खेती, उत्पादों, ऑफ़र और प्रोग्राम से जुड़ी जानकारी के लिए आपसे कॉल, SMS या WhatsApp के माध्यम से संपर्क कर सकते हैं।\n\nआपकी जानकारी कोर्टेवा की गोपनीयता नीति के अनुसार सुरक्षित रखी जाएगी। आप कभी भी संपर्क करके अपनी सहमति वापस ले सकते हैं।\n\n'सबमिट' बटन पर क्लिक करके, आप उपरोक्त शर्तों से सहमत होते हैं।",
      "ChangeLanguage": "ভাষা পরিবর্তন করুন",
      "consentAgree": "সম্মত",
      "consentDecline": "প্রত্যাখ্যান করুন",
      "ShareNow": "এখনই শেয়ার করুন",
      "gallant_usedErrorMsg": "Please select whether Gallant was used.",
      "will_buy_strongarm_this_seasonErrorMsg": "Please select when Strongarm will be purchased.",
      "bottleScan": "बोतल स्कैन किए",
      "big_prize_opportunity_title": "बड़े इनाम जीतने का मौका",
      "big_prize_opportunity_desc": "ज़्यादा स्कैन, बड़े इनाम",
      "scan_more": "और स्कैन करें",
      "scan_more_win_bigger_gifts_title": "और स्कैन करें, बड़े उपहार जीतें!",
      "scan_more_win_bigger_gifts_desc": "हर अतिरिक्त स्कैन आपको शानदार पुरस्कारों के करीब लाता है।",
      "next_gift_label": "अगले उपहार के लिए",
      "scan_more_packets_label": "और बोतल स्कैन करें।",
      "reward_history": "Reward History",
      "scanned_products": "स्कैन किए गए उत्पाद",
      "scan_date": "स्कैन की तारीख",
      "packet_id": "बोतल आईडी",
      "gift_history": "उपहारों का इतिहास",
      "reward_win_date": "पुरस्कार जीतने की तारीख",
      "reward": "पुरस्कार",
      "status": "स्थिति",
      "share": "शेयर करें",
      "have_they_used_gallant": "Have they used Gallant in the past?"
    }
  },
  ma: {
    "translation": {
      Next: "Next",
      shareText: "I have received a winning Lucky Draw code. Please purchase Strongarm and you can also stand a chance to win.",
      Share: "Share",
      confirmation: "Confirmation",
      All_products_Scanned: "All products Scanned ?",
      No: "No",
      Yes: "Yes",
      invalid_OTP: "Invalid OTP ",
      resend_OTP: "Resend OTP",
      Mega_Draw_Code: "Mega Draw Code",
      Reward_Won: "Reward Won",
      all_set: "You're all set!",
      go_step2: "Go to Step 2",
      Spin_Wheel_Win: "Spin the Wheel & Win!",
      Spin_Wheel: "Spin Wheel",
      language: "malayalam",
      Eligible_to_win: "You are now Eligible to win",
      Spin_Now: "Spin Now",
      Spin_Win: "Spin and Win",
      Product_Serial_Number: "Product Serial Number",
      total_acresErrorMsg: "Please enter acres",
      visit: "Visit",
      Name: "Name",
      Strongarm_Survey: "Strongarm Survey",
      "sessionExperied": "The session has ended. Please scan the QR code.",
      "profileText": " Your profile is getting created in Corteva Farmer Connect app. Please complete your registration",
      "termsandconiditionsURL": "http://uat.farmerconnect.in:7000/tracer-microsite/hindi/termsandconditions.php",
      "delegate": "Engage",
      "loginLabel": "Mobile Number",
      "loginPlaceHolder": "Enter Mobile Number",
      "mobileErrorMsg": "Please enter mobile number",
      "submitBtn": "Submit",
      "loginBtn": "Login",
      "otpText": "OTP will be sent as an SMS to {mobileNumber}",
      "otpError": "Please enter a valid OTP",
      "OTPLabel": "OTP",
      "firstName": "First Name",
      "firstNameErrorMsg": "Please enter first name",
      "lastName": "Last Name",
      "lastNameErrorMsg": "Please enter last name",
      "pincode": "Pincode",
      "address": "Address",
      "done": "Done",
      "submit": "Submit",
      "scanTitle": "Scan the QR code",
      "scanning": "Scanning",
      "scan": "Scan",
      "rescan": "Rescan",
      "scanSteps": "Steps to scan the QR code",
      "stepOne": "Step 1: Find the QR code on the pouch",
      "stepTwo": "Step 2: Scan the QR code and submit",
      "spinToWin": "Join the Engage Program",
      "scanProduct": "Scan Product",
      "SpinWheel": "Spin the wheel to win prizes",
      "congratulations": "Congratulations",
      "giftcongratulations": "Congratulations, you are a winner!",
      "earned": "You have earned Rs. 20.00 cash for Engage",
      "redeemCash": "Get Cash Payment",
      "ClaimReward": "Claim Reward",
      "updatesOnReward": "You are a winner with Engage. Contact your local Corteva representative for updates on the reward",
      "paymentMode": "Select Payment Mode",
      "bankDetails": "Bank Details",
      "accountHolderName": "Account Holder Name",
      "accountHolderNameErrorMsg": "Account holder name is required",
      "accountNumber": "Account Number",
      "accountNumberErrorMsg": "Please enter account number",
      "IFSCCode": "IFSC Code",
      "IFSCCodeErrorMsg": "Please enter IFSC code",
      "confirm": "Confirm",
      "UPIErrorMsg": "UPI required",
      "transferSuccessText": "Your cash transfer <br> is successful",
      "successSubtitile": "We have sent your money!",
      "goHome": "Go to Home Page",
      "delegateRewards": "Engage Rewards",
      "claimList": "Claim List",
      "noClaimsFound": "No claims found",
      "noSuccessList": "No success list found",
      "reclaimList": "Reclaim List",
      "noReclaimList": "No reclaim list found",
      "agreeText": "By submitting, you agree to our terms",
      "genuityCheck": "Product Authenticity Check",
      "resendOtp": "Resend OTP",
      "productName": "Product",
      "serialNO": "Serial No.",
      "alreadyLoginText": "Your number is also logged in to the Farmer Connect app. Press OK to log in.",
      "notRegisteredText": "Your number is not registered. Please register to participate in Engage Blast.",
      "loginConfirm": "Login Confirmation",
      "Alert": "Alert!",
      "no": "No",
      "yes": "Yes",
      "OK": "OK",
      "amount": "Amount",
      "Date": "Date",
      "claim": "Claim",
      "successList": "Success List",
      "referenceId": "Reference ID",
      "status": "Status",
      "Scanmore": "Scan More",
      "Rewards": "Rewards",
      "reward": "Reward",
      "transfer": "Transfer",
      "home": "Home",
      "TC": "T&C",
      "ProductInfo": "Product <br> Information",
      "downloadBrochure": "Download Brochure <br> ",
      "programDetails": "Program Details",
      "delegateParticipate": "Engage Friendship Blast - Participate",
      "termsAndConditions": "Terms and Conditions",
      "award": "Award",
      "TermsandConditons": "Terms and Conditions",
      "and": "and",
      "privacyPolicy": "Privacy Policy",
      "BackToHome": "Back to Home Page",
      "ReferenceId": "Reference ID",
      "noData": "No data available",
      "mblnumberPlaceHolder": "Retailer's Mobile Number",
      "name": "Name",
      "cottn": "Cotton",
      "corn": "Corn",
      "enterOTP": "Enter OTP",
      "login": "Login",
      "scanagain": "Scan Again",
      "cropErrorMsg": "Please select a crop",
      "nameErrorMsg": "Please enter your name",
      "Reclaim": "Reclaim",
      "Skip": "Skip",
      "Claim": "Claim",
      "StepsImage": "Engage Double Blast - How to Participate",
      "UPI": "UPI",
      "confirmaccountNumber": "Confirm Account Number",
      "confirmaccountNumberErrorMsg": "Please enter Confirm Account Number",
      "confirmAccountNumberMismatch": 'The account number confirmation account number does not match',
      "cortevaInfo": "आपका नाम 'Corteva Farmer Connect' ऐप में जोड़ा (रजिस्टर किया) जा रहा है। जानकारी भरकर आप कोर्टेवा को अनुमति देते हैं कि वे समय-समय पर खेती और उत्पादों से जुड़ी जानकारी के लिए आपसे संपर्क करें।",
      selectPayment: {
        cashbackAmountLabel: "ക്യാഷ്ബാക്ക് തുക",
        proceedButton: "തുടരുക",
        bankDetails: "ബാങ്ക് അക്കൗണ്ട്",
        upi: "യുപിഐ",
      },
      scanProductPage: {
        whatsappHelp: "സഹായം ആവശ്യമുണ്ടോ? WhatsApp ൽ ബന്ധപ്പെടുക",
      },
      "knowmore": "अधिक जानें",
      "consentDetailsTitle": "सहमति विवरण",
      "consentDetails": "आपका नाम 'Corteva Farmer Connect' ऐप में पंजीकृत किया जा रहा है।\n\nआप जो व्यक्तिगत जानकारी (नाम, मोबाइल नंबर, फसल विवरण आदि) प्रदान करते हैं, वह Strongarm™ प्रोग्राम और संबंधित सेवाओं के लिए उपयोग की जाएगी।\n\nआप कोर्टेवा एग्रीसाइंस को यह अनुमति देते हैं कि वे समय-समय पर खेती, उत्पादों, ऑफ़र और प्रोग्राम से जुड़ी जानकारी के लिए आपसे कॉल, SMS या WhatsApp के माध्यम से संपर्क कर सकते हैं।\n\nआपकी जानकारी कोर्टेवा की गोपनीयता नीति के अनुसार सुरक्षित रखी जाएगी। आप कभी भी संपर्क करके अपनी सहमति वापस ले सकते हैं।\n\n'सबमिट' बटन पर क्लिक करके, आप उपरोक्त शर्तों से सहमत होते हैं।"
    },
    "gallant_usedErrorMsg": "Please select whether Gallant was used.",
    "will_buy_strongarm_this_seasonErrorMsg": "Please select when Strongarm will be purchased.",
    "bottleScan": "बोतल स्कैन किए",
    "big_prize_opportunity_title": "बड़े इनाम जीतने का मौका",
    "big_prize_opportunity_desc": "ज़्यादा स्कैन, बड़े इनाम",
    "scan_more": "और स्कैन करें",
    "scan_more_win_bigger_gifts_title": "और स्कैन करें, बड़े उपहार जीतें!",
    "scan_more_win_bigger_gifts_desc": "हर अतिरिक्त स्कैन आपको शानदार पुरस्कारों के करीब लाता है।",
    "next_gift_label": "अगले उपहार के लिए",
    "scan_more_packets_label": "और बोतल स्कैन करें।",
    "reward_history": "Reward History",
    "scanned_products": "स्कैन किए गए उत्पाद",
    "scan_date": "स्कैन की तारीख",
    "packet_id": "बोतल आईडी",
    "gift_history": "उपहारों का इतिहास",
    "reward_win_date": "पुरस्कार जीतने की तारीख",
    "reward": "पुरस्कार",
    "status": "स्थिति",
    "share": "शेयर करें",
    "have_they_used_gallant": "Have they used Gallant in the past?"
  },
};

export default resources;
